function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch(e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));
    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const min = parseInt(this.input.min);
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus.classList.toggle('disabled', value <= min);
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button:not(.localization-selector)').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach(submenu => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header && document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this, false)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
      if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor((this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderItemOffset) : this.slider.scrollLeft - (step * this.sliderItemOffset);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length) linkElements.forEach(button => {
          button.removeAttribute('tabindex');
        });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length) linkElements.forEach(button => {
          button.setAttribute('tabindex', '-1');
        });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGalleries = document.querySelectorAll(`[id^="MediaGallery-${this.dataset.section}"]`);
    mediaGalleries.forEach(mediaGallery => mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true));

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(variant => this.querySelector(':checked').value === variant.option1);
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')]
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants.filter(variant => variant.available && variant[`option${ index }`] === previousOptionSelected).map(variantOption => variantOption[`option${ index + 1 }`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue)
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.innerText = input.getAttribute('value');
      } else {
        input.innerText = window.variantStrings.unavailable_with_option.replace('[value]', input.getAttribute('value'));
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;

    fetch(`${this.dataset.url}?variant=${requestedVariantId}&section_id=${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(`price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuSource = html.getElementById(`Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(`Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`);
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        if (source && destination) destination.innerHTML = source.innerHTML;
        if (inventorySource && inventoryDestination) inventoryDestination.innerHTML = inventorySource.innerHTML;
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('visibility-hidden', skuSource.classList.contains('visibility-hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('visibility-hidden');

        if (inventoryDestination) inventoryDestination.classList.toggle('visibility-hidden', inventorySource.innerText === '');

        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true, window.variantStrings.soldOut);

        publish(PUB_SUB_EVENTS.variantChange, {data: {
          sectionId,
          html,
          variant: this.currentVariant
        }});
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);

    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
    if (inventory) inventory.classList.add('visibility-hidden');
    if (sku) sku.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach(input => {
      if (listOfAvailableOptions.includes(input.getAttribute('value'))) {
        input.classList.remove('disabled');
      } else {
        input.classList.add('disabled');
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll('fieldset'));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
    });
  }
}

customElements.define('variant-radios', VariantRadios);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch(e => {
          console.error(e);
        });
    }

    new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 400px 0px'}).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);


// OLD SCRIPTS
!function(e){"use strict";"function"==typeof define&&define.amd?define(["jquery"],e):"undefined"!=typeof exports?module.exports=e(require("jquery")):e(jQuery)}(function(d){"use strict";var n,r=window.Slick||{};n=0,(r=function(e,t){var i,s=this;s.defaults={accessibility:!0,adaptiveHeight:!1,appendArrows:d(e),appendDots:d(e),arrows:!0,asNavFor:null,prevArrow:'<button class="slick-prev" aria-label="Previous" type="button">Previous</button>',nextArrow:'<button class="slick-next" aria-label="Next" type="button">Next</button>',autoplay:!1,autoplaySpeed:3e3,centerMode:!1,centerPadding:"50px",cssEase:"ease",customPaging:function(e,t){return d('<button type="button" />').text(t+1)},dots:!1,dotsClass:"slick-dots",draggable:!0,easing:"linear",edgeFriction:.35,fade:!1,focusOnSelect:!1,focusOnChange:!1,infinite:!0,initialSlide:0,lazyLoad:"ondemand",mobileFirst:!1,pauseOnHover:!0,pauseOnFocus:!0,pauseOnDotsHover:!1,respondTo:"window",responsive:null,rows:1,rtl:!1,slide:"",slidesPerRow:1,slidesToShow:1,slidesToScroll:1,speed:500,swipe:!0,swipeToSlide:!1,touchMove:!0,touchThreshold:5,useCSS:!0,useTransform:!0,variableWidth:!1,vertical:!1,verticalSwiping:!1,waitForAnimate:!0,zIndex:1e3},s.initials={animating:!1,dragging:!1,autoPlayTimer:null,currentDirection:0,currentLeft:null,currentSlide:0,direction:1,$dots:null,listWidth:null,listHeight:null,loadIndex:0,$nextArrow:null,$prevArrow:null,scrolling:!1,slideCount:null,slideWidth:null,$slideTrack:null,$slides:null,sliding:!1,slideOffset:0,swipeLeft:null,swiping:!1,$list:null,touchObject:{},transformsEnabled:!1,unslicked:!1},d.extend(s,s.initials),s.activeBreakpoint=null,s.animType=null,s.animProp=null,s.breakpoints=[],s.breakpointSettings=[],s.cssTransitions=!1,s.focussed=!1,s.interrupted=!1,s.hidden="hidden",s.paused=!0,s.positionProp=null,s.respondTo=null,s.rowCount=1,s.shouldClick=!0,s.$slider=d(e),s.$slidesCache=null,s.transformType=null,s.transitionType=null,s.visibilityChange="visibilitychange",s.windowWidth=0,s.windowTimer=null,i=d(e).data("slick")||{},s.options=d.extend({},s.defaults,t,i),s.currentSlide=s.options.initialSlide,s.originalSettings=s.options,void 0!==document.mozHidden?(s.hidden="mozHidden",s.visibilityChange="mozvisibilitychange"):void 0!==document.webkitHidden&&(s.hidden="webkitHidden",s.visibilityChange="webkitvisibilitychange"),s.autoPlay=d.proxy(s.autoPlay,s),s.autoPlayClear=d.proxy(s.autoPlayClear,s),s.autoPlayIterator=d.proxy(s.autoPlayIterator,s),s.changeSlide=d.proxy(s.changeSlide,s),s.clickHandler=d.proxy(s.clickHandler,s),s.selectHandler=d.proxy(s.selectHandler,s),s.setPosition=d.proxy(s.setPosition,s),s.swipeHandler=d.proxy(s.swipeHandler,s),s.dragHandler=d.proxy(s.dragHandler,s),s.keyHandler=d.proxy(s.keyHandler,s),s.instanceUid=n++,s.htmlExpr=/^(?:\s*(<[\w\W]+>)[^>]*)$/,s.registerBreakpoints(),s.init(!0)}).prototype.activateADA=function(){this.$slideTrack.find(".slick-active").attr({"aria-hidden":"false"}).find("a, input, button, select").attr({tabindex:"0"})},r.prototype.addSlide=r.prototype.slickAdd=function(e,t,i){var s=this;if("boolean"==typeof t)i=t,t=null;else if(t<0||t>=s.slideCount)return!1;s.unload(),"number"==typeof t?0===t&&0===s.$slides.length?d(e).appendTo(s.$slideTrack):i?d(e).insertBefore(s.$slides.eq(t)):d(e).insertAfter(s.$slides.eq(t)):!0===i?d(e).prependTo(s.$slideTrack):d(e).appendTo(s.$slideTrack),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slides.each(function(e,t){d(t).attr("data-slick-index",e)}),s.$slidesCache=s.$slides,s.reinit()},r.prototype.animateHeight=function(){var e,t=this;1===t.options.slidesToShow&&!0===t.options.adaptiveHeight&&!1===t.options.vertical&&(e=t.$slides.eq(t.currentSlide).outerHeight(!0),t.$list.animate({height:e},t.options.speed))},r.prototype.animateSlide=function(e,t){var i={},s=this;s.animateHeight(),!0===s.options.rtl&&!1===s.options.vertical&&(e=-e),!1===s.transformsEnabled?!1===s.options.vertical?s.$slideTrack.animate({left:e},s.options.speed,s.options.easing,t):s.$slideTrack.animate({top:e},s.options.speed,s.options.easing,t):!1===s.cssTransitions?(!0===s.options.rtl&&(s.currentLeft=-s.currentLeft),d({animStart:s.currentLeft}).animate({animStart:e},{duration:s.options.speed,easing:s.options.easing,step:function(e){e=Math.ceil(e),!1===s.options.vertical?i[s.animType]="translate("+e+"px, 0px)":i[s.animType]="translate(0px,"+e+"px)",s.$slideTrack.css(i)},complete:function(){t&&t.call()}})):(s.applyTransition(),e=Math.ceil(e),!1===s.options.vertical?i[s.animType]="translate3d("+e+"px, 0px, 0px)":i[s.animType]="translate3d(0px,"+e+"px, 0px)",s.$slideTrack.css(i),t&&setTimeout(function(){s.disableTransition(),t.call()},s.options.speed))},r.prototype.getNavTarget=function(){var e=this.options.asNavFor;return e&&null!==e&&(e=d(e).not(this.$slider)),e},r.prototype.asNavFor=function(t){var e=this.getNavTarget();null!==e&&"object"==typeof e&&e.each(function(){var e=d(this).slick("getSlick");e.unslicked||e.slideHandler(t,!0)})},r.prototype.applyTransition=function(e){var t=this,i={};!1===t.options.fade?i[t.transitionType]=t.transformType+" "+t.options.speed+"ms "+t.options.cssEase:i[t.transitionType]="opacity "+t.options.speed+"ms "+t.options.cssEase,!1===t.options.fade?t.$slideTrack.css(i):t.$slides.eq(e).css(i)},r.prototype.autoPlay=function(){var e=this;e.autoPlayClear(),e.slideCount>e.options.slidesToShow&&(e.autoPlayTimer=setInterval(e.autoPlayIterator,e.options.autoplaySpeed))},r.prototype.autoPlayClear=function(){this.autoPlayTimer&&clearInterval(this.autoPlayTimer)},r.prototype.autoPlayIterator=function(){var e=this,t=e.currentSlide+e.options.slidesToScroll;e.paused||e.interrupted||e.focussed||(!1===e.options.infinite&&(1===e.direction&&e.currentSlide+1===e.slideCount-1?e.direction=0:0===e.direction&&(t=e.currentSlide-e.options.slidesToScroll,e.currentSlide-1==0&&(e.direction=1))),e.slideHandler(t))},r.prototype.buildArrows=function(){var e=this;!0===e.options.arrows&&(e.$prevArrow=d(e.options.prevArrow).addClass("slick-arrow"),e.$nextArrow=d(e.options.nextArrow).addClass("slick-arrow"),e.slideCount>e.options.slidesToShow?(e.$prevArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.$nextArrow.removeClass("slick-hidden").removeAttr("aria-hidden tabindex"),e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.prependTo(e.options.appendArrows),e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.appendTo(e.options.appendArrows),!0!==e.options.infinite&&e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true")):e.$prevArrow.add(e.$nextArrow).addClass("slick-hidden").attr({"aria-disabled":"true",tabindex:"-1"}))},r.prototype.buildDots=function(){var e,t,i=this;if(!0===i.options.dots&&i.slideCount>i.options.slidesToShow){for(i.$slider.addClass("slick-dotted"),t=d("<ul />").addClass(i.options.dotsClass),e=0;e<=i.getDotCount();e+=1)t.append(d("<li />").append(i.options.customPaging.call(this,i,e)));i.$dots=t.appendTo(i.options.appendDots),i.$dots.find("li").first().addClass("slick-active")}},r.prototype.buildOut=function(){var e=this;e.$slides=e.$slider.children(e.options.slide+":not(.slick-cloned)").addClass("slick-slide"),e.slideCount=e.$slides.length,e.$slides.each(function(e,t){d(t).attr("data-slick-index",e).data("originalStyling",d(t).attr("style")||"")}),e.$slider.addClass("slick-slider"),e.$slideTrack=0===e.slideCount?d('<div class="slick-track"/>').appendTo(e.$slider):e.$slides.wrapAll('<div class="slick-track"/>').parent(),e.$list=e.$slideTrack.wrap('<div class="slick-list"/>').parent(),e.$slideTrack.css("opacity",0),!0!==e.options.centerMode&&!0!==e.options.swipeToSlide||(e.options.slidesToScroll=1),d("img[data-lazy]",e.$slider).not("[src]").addClass("slick-loading"),e.setupInfinite(),e.buildArrows(),e.buildDots(),e.updateDots(),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),!0===e.options.draggable&&e.$list.addClass("draggable")},r.prototype.buildRows=function(){var e,t,i,s=this,n=document.createDocumentFragment(),o=s.$slider.children();if(0<s.options.rows){for(i=s.options.slidesPerRow*s.options.rows,t=Math.ceil(o.length/i),e=0;e<t;e++){for(var r=document.createElement("div"),a=0;a<s.options.rows;a++){for(var l=document.createElement("div"),d=0;d<s.options.slidesPerRow;d++){var c=e*i+(a*s.options.slidesPerRow+d);o.get(c)&&l.appendChild(o.get(c))}r.appendChild(l)}n.appendChild(r)}s.$slider.empty().append(n),s.$slider.children().children().children().css({width:100/s.options.slidesPerRow+"%",display:"inline-block"})}},r.prototype.checkResponsive=function(e,t){var i,s,n,o=this,r=!1,a=o.$slider.width(),l=window.innerWidth||d(window).width();if("window"===o.respondTo?n=l:"slider"===o.respondTo?n=a:"min"===o.respondTo&&(n=Math.min(l,a)),o.options.responsive&&o.options.responsive.length&&null!==o.options.responsive){for(i in s=null,o.breakpoints)o.breakpoints.hasOwnProperty(i)&&(!1===o.originalSettings.mobileFirst?n<o.breakpoints[i]&&(s=o.breakpoints[i]):n>o.breakpoints[i]&&(s=o.breakpoints[i]));null!==s?null!==o.activeBreakpoint&&s===o.activeBreakpoint&&!t||(o.activeBreakpoint=s,"unslick"===o.breakpointSettings[s]?o.unslick(s):(o.options=d.extend({},o.originalSettings,o.breakpointSettings[s]),!0===e&&(o.currentSlide=o.options.initialSlide),o.refresh(e)),r=s):null!==o.activeBreakpoint&&(o.activeBreakpoint=null,o.options=o.originalSettings,!0===e&&(o.currentSlide=o.options.initialSlide),o.refresh(e),r=s),e||!1===r||o.$slider.trigger("breakpoint",[o,r])}},r.prototype.changeSlide=function(e,t){var i,s,n=this,o=d(e.currentTarget);switch(o.is("a")&&e.preventDefault(),o.is("li")||(o=o.closest("li")),i=n.slideCount%n.options.slidesToScroll!=0?0:(n.slideCount-n.currentSlide)%n.options.slidesToScroll,e.data.message){case"previous":s=0==i?n.options.slidesToScroll:n.options.slidesToShow-i,n.slideCount>n.options.slidesToShow&&n.slideHandler(n.currentSlide-s,!1,t);break;case"next":s=0==i?n.options.slidesToScroll:i,n.slideCount>n.options.slidesToShow&&n.slideHandler(n.currentSlide+s,!1,t);break;case"index":var r=0===e.data.index?0:e.data.index||o.index()*n.options.slidesToScroll;n.slideHandler(n.checkNavigable(r),!1,t),o.children().trigger("focus");break;default:return}},r.prototype.checkNavigable=function(e){var t=this.getNavigableIndexes(),i=0;if(e>t[t.length-1])e=t[t.length-1];else for(var s in t){if(e<t[s]){e=i;break}i=t[s]}return e},r.prototype.cleanUpEvents=function(){var e=this;e.options.dots&&null!==e.$dots&&(d("li",e.$dots).off("click.slick",e.changeSlide).off("mouseenter.slick",d.proxy(e.interrupt,e,!0)).off("mouseleave.slick",d.proxy(e.interrupt,e,!1)),!0===e.options.accessibility&&e.$dots.off("keydown.slick",e.keyHandler)),e.$slider.off("focus.slick blur.slick"),!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow&&e.$prevArrow.off("click.slick",e.changeSlide),e.$nextArrow&&e.$nextArrow.off("click.slick",e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow&&e.$prevArrow.off("keydown.slick",e.keyHandler),e.$nextArrow&&e.$nextArrow.off("keydown.slick",e.keyHandler))),e.$list.off("touchstart.slick mousedown.slick",e.swipeHandler),e.$list.off("touchmove.slick mousemove.slick",e.swipeHandler),e.$list.off("touchend.slick mouseup.slick",e.swipeHandler),e.$list.off("touchcancel.slick mouseleave.slick",e.swipeHandler),e.$list.off("click.slick",e.clickHandler),d(document).off(e.visibilityChange,e.visibility),e.cleanUpSlideEvents(),!0===e.options.accessibility&&e.$list.off("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&d(e.$slideTrack).children().off("click.slick",e.selectHandler),d(window).off("orientationchange.slick.slick-"+e.instanceUid,e.orientationChange),d(window).off("resize.slick.slick-"+e.instanceUid,e.resize),d("[draggable!=true]",e.$slideTrack).off("dragstart",e.preventDefault),d(window).off("load.slick.slick-"+e.instanceUid,e.setPosition)},r.prototype.cleanUpSlideEvents=function(){var e=this;e.$list.off("mouseenter.slick",d.proxy(e.interrupt,e,!0)),e.$list.off("mouseleave.slick",d.proxy(e.interrupt,e,!1))},r.prototype.cleanUpRows=function(){var e;0<this.options.rows&&((e=this.$slides.children().children()).removeAttr("style"),this.$slider.empty().append(e))},r.prototype.clickHandler=function(e){!1===this.shouldClick&&(e.stopImmediatePropagation(),e.stopPropagation(),e.preventDefault())},r.prototype.destroy=function(e){var t=this;t.autoPlayClear(),t.touchObject={},t.cleanUpEvents(),d(".slick-cloned",t.$slider).detach(),t.$dots&&t.$dots.remove(),t.$prevArrow&&t.$prevArrow.length&&(t.$prevArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.prevArrow)&&t.$prevArrow.remove()),t.$nextArrow&&t.$nextArrow.length&&(t.$nextArrow.removeClass("slick-disabled slick-arrow slick-hidden").removeAttr("aria-hidden aria-disabled tabindex").css("display",""),t.htmlExpr.test(t.options.nextArrow)&&t.$nextArrow.remove()),t.$slides&&(t.$slides.removeClass("slick-slide slick-active slick-center slick-visible slick-current").removeAttr("aria-hidden").removeAttr("data-slick-index").each(function(){d(this).attr("style",d(this).data("originalStyling"))}),t.$slideTrack.children(this.options.slide).detach(),t.$slideTrack.detach(),t.$list.detach(),t.$slider.append(t.$slides)),t.cleanUpRows(),t.$slider.removeClass("slick-slider"),t.$slider.removeClass("slick-initialized"),t.$slider.removeClass("slick-dotted"),t.unslicked=!0,e||t.$slider.trigger("destroy",[t])},r.prototype.disableTransition=function(e){var t={};t[this.transitionType]="",!1===this.options.fade?this.$slideTrack.css(t):this.$slides.eq(e).css(t)},r.prototype.fadeSlide=function(e,t){var i=this;!1===i.cssTransitions?(i.$slides.eq(e).css({zIndex:i.options.zIndex}),i.$slides.eq(e).animate({opacity:1},i.options.speed,i.options.easing,t)):(i.applyTransition(e),i.$slides.eq(e).css({opacity:1,zIndex:i.options.zIndex}),t&&setTimeout(function(){i.disableTransition(e),t.call()},i.options.speed))},r.prototype.fadeSlideOut=function(e){var t=this;!1===t.cssTransitions?t.$slides.eq(e).animate({opacity:0,zIndex:t.options.zIndex-2},t.options.speed,t.options.easing):(t.applyTransition(e),t.$slides.eq(e).css({opacity:0,zIndex:t.options.zIndex-2}))},r.prototype.filterSlides=r.prototype.slickFilter=function(e){var t=this;null!==e&&(t.$slidesCache=t.$slides,t.unload(),t.$slideTrack.children(this.options.slide).detach(),t.$slidesCache.filter(e).appendTo(t.$slideTrack),t.reinit())},r.prototype.focusHandler=function(){var i=this;i.$slider.off("focus.slick blur.slick").on("focus.slick","*",function(e){var t=d(this);setTimeout(function(){i.options.pauseOnFocus&&t.is(":focus")&&(i.focussed=!0,i.autoPlay())},0)}).on("blur.slick","*",function(e){d(this);i.options.pauseOnFocus&&(i.focussed=!1,i.autoPlay())})},r.prototype.getCurrent=r.prototype.slickCurrentSlide=function(){return this.currentSlide},r.prototype.getDotCount=function(){var e=this,t=0,i=0,s=0;if(!0===e.options.infinite)if(e.slideCount<=e.options.slidesToShow)++s;else for(;t<e.slideCount;)++s,t=i+e.options.slidesToScroll,i+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;else if(!0===e.options.centerMode)s=e.slideCount;else if(e.options.asNavFor)for(;t<e.slideCount;)++s,t=i+e.options.slidesToScroll,i+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;else s=1+Math.ceil((e.slideCount-e.options.slidesToShow)/e.options.slidesToScroll);return s-1},r.prototype.getLeft=function(e){var t,i,s,n,o=this,r=0;return o.slideOffset=0,i=o.$slides.first().outerHeight(!0),!0===o.options.infinite?(o.slideCount>o.options.slidesToShow&&(o.slideOffset=o.slideWidth*o.options.slidesToShow*-1,n=-1,!0===o.options.vertical&&!0===o.options.centerMode&&(2===o.options.slidesToShow?n=-1.5:1===o.options.slidesToShow&&(n=-2)),r=i*o.options.slidesToShow*n),o.slideCount%o.options.slidesToScroll!=0&&e+o.options.slidesToScroll>o.slideCount&&o.slideCount>o.options.slidesToShow&&(r=e>o.slideCount?(o.slideOffset=(o.options.slidesToShow-(e-o.slideCount))*o.slideWidth*-1,(o.options.slidesToShow-(e-o.slideCount))*i*-1):(o.slideOffset=o.slideCount%o.options.slidesToScroll*o.slideWidth*-1,o.slideCount%o.options.slidesToScroll*i*-1))):e+o.options.slidesToShow>o.slideCount&&(o.slideOffset=(e+o.options.slidesToShow-o.slideCount)*o.slideWidth,r=(e+o.options.slidesToShow-o.slideCount)*i),o.slideCount<=o.options.slidesToShow&&(r=o.slideOffset=0),!0===o.options.centerMode&&o.slideCount<=o.options.slidesToShow?o.slideOffset=o.slideWidth*Math.floor(o.options.slidesToShow)/2-o.slideWidth*o.slideCount/2:!0===o.options.centerMode&&!0===o.options.infinite?o.slideOffset+=o.slideWidth*Math.floor(o.options.slidesToShow/2)-o.slideWidth:!0===o.options.centerMode&&(o.slideOffset=0,o.slideOffset+=o.slideWidth*Math.floor(o.options.slidesToShow/2)),t=!1===o.options.vertical?e*o.slideWidth*-1+o.slideOffset:e*i*-1+r,!0===o.options.variableWidth&&(s=o.slideCount<=o.options.slidesToShow||!1===o.options.infinite?o.$slideTrack.children(".slick-slide").eq(e):o.$slideTrack.children(".slick-slide").eq(e+o.options.slidesToShow),t=!0===o.options.rtl?s[0]?-1*(o.$slideTrack.width()-s[0].offsetLeft-s.width()):0:s[0]?-1*s[0].offsetLeft:0,!0===o.options.centerMode&&(s=o.slideCount<=o.options.slidesToShow||!1===o.options.infinite?o.$slideTrack.children(".slick-slide").eq(e):o.$slideTrack.children(".slick-slide").eq(e+o.options.slidesToShow+1),t=!0===o.options.rtl?s[0]?-1*(o.$slideTrack.width()-s[0].offsetLeft-s.width()):0:s[0]?-1*s[0].offsetLeft:0,t+=(o.$list.width()-s.outerWidth())/2)),t},r.prototype.getOption=r.prototype.slickGetOption=function(e){return this.options[e]},r.prototype.getNavigableIndexes=function(){for(var e=this,t=0,i=0,s=[],n=!1===e.options.infinite?e.slideCount:(t=-1*e.options.slidesToScroll,i=-1*e.options.slidesToScroll,2*e.slideCount);t<n;)s.push(t),t=i+e.options.slidesToScroll,i+=e.options.slidesToScroll<=e.options.slidesToShow?e.options.slidesToScroll:e.options.slidesToShow;return s},r.prototype.getSlick=function(){return this},r.prototype.getSlideCount=function(){var n,o=this,e=!0===o.options.centerMode?Math.floor(o.$list.width()/2):0,r=-1*o.swipeLeft+e;return!0===o.options.swipeToSlide?(o.$slideTrack.find(".slick-slide").each(function(e,t){var i=d(t).outerWidth(),s=t.offsetLeft;if(!0!==o.options.centerMode&&(s+=i/2),r<s+i)return n=t,!1}),Math.abs(d(n).attr("data-slick-index")-o.currentSlide)||1):o.options.slidesToScroll},r.prototype.goTo=r.prototype.slickGoTo=function(e,t){this.changeSlide({data:{message:"index",index:parseInt(e)}},t)},r.prototype.init=function(e){var t=this;d(t.$slider).hasClass("slick-initialized")||(d(t.$slider).addClass("slick-initialized"),t.buildRows(),t.buildOut(),t.setProps(),t.startLoad(),t.loadSlider(),t.initializeEvents(),t.updateArrows(),t.updateDots(),t.checkResponsive(!0),t.focusHandler()),e&&t.$slider.trigger("init",[t]),!0===t.options.accessibility&&t.initADA(),t.options.autoplay&&(t.paused=!1,t.autoPlay())},r.prototype.initADA=function(){var s=this,i=Math.ceil(s.slideCount/s.options.slidesToShow),n=s.getNavigableIndexes().filter(function(e){return 0<=e&&e<s.slideCount});s.$slides.add(s.$slideTrack.find(".slick-cloned")).attr({"aria-hidden":"true",tabindex:"-1"}).find("a, input, button, select").attr({tabindex:"-1"}),null!==s.$dots&&(s.$slides.not(s.$slideTrack.find(".slick-cloned")).each(function(e){var t,i=n.indexOf(e);d(this).attr({role:"tabpanel",id:"slick-slide"+s.instanceUid+e,tabindex:-1}),-1!==i&&(t="slick-slide-control"+s.instanceUid+i,d("#"+t).length&&d(this).attr({"aria-describedby":t}))}),s.$dots.attr("role","tablist").find("li").each(function(e){var t=n[e];d(this).attr({role:"presentation"}),d(this).find("button").first().attr({role:"tab",id:"slick-slide-control"+s.instanceUid+e,"aria-controls":"slick-slide"+s.instanceUid+t,"aria-label":e+1+" of "+i,"aria-selected":null,tabindex:"-1"})}).eq(s.currentSlide).find("button").attr({"aria-selected":"true",tabindex:"0"}).end());for(var e=s.currentSlide,t=e+s.options.slidesToShow;e<t;e++)s.options.focusOnChange?s.$slides.eq(e).attr({tabindex:"0"}):s.$slides.eq(e).removeAttr("tabindex");s.activateADA()},r.prototype.initArrowEvents=function(){var e=this;!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow.off("click.slick").on("click.slick",{message:"previous"},e.changeSlide),e.$nextArrow.off("click.slick").on("click.slick",{message:"next"},e.changeSlide),!0===e.options.accessibility&&(e.$prevArrow.on("keydown.slick",e.keyHandler),e.$nextArrow.on("keydown.slick",e.keyHandler)))},r.prototype.initDotEvents=function(){var e=this;!0===e.options.dots&&e.slideCount>e.options.slidesToShow&&(d("li",e.$dots).on("click.slick",{message:"index"},e.changeSlide),!0===e.options.accessibility&&e.$dots.on("keydown.slick",e.keyHandler)),!0===e.options.dots&&!0===e.options.pauseOnDotsHover&&e.slideCount>e.options.slidesToShow&&d("li",e.$dots).on("mouseenter.slick",d.proxy(e.interrupt,e,!0)).on("mouseleave.slick",d.proxy(e.interrupt,e,!1))},r.prototype.initSlideEvents=function(){var e=this;e.options.pauseOnHover&&(e.$list.on("mouseenter.slick",d.proxy(e.interrupt,e,!0)),e.$list.on("mouseleave.slick",d.proxy(e.interrupt,e,!1)))},r.prototype.initializeEvents=function(){var e=this;e.initArrowEvents(),e.initDotEvents(),e.initSlideEvents(),e.$list.on("touchstart.slick mousedown.slick",{action:"start"},e.swipeHandler),e.$list.on("touchmove.slick mousemove.slick",{action:"move"},e.swipeHandler),e.$list.on("touchend.slick mouseup.slick",{action:"end"},e.swipeHandler),e.$list.on("touchcancel.slick mouseleave.slick",{action:"end"},e.swipeHandler),e.$list.on("click.slick",e.clickHandler),d(document).on(e.visibilityChange,d.proxy(e.visibility,e)),!0===e.options.accessibility&&e.$list.on("keydown.slick",e.keyHandler),!0===e.options.focusOnSelect&&d(e.$slideTrack).children().on("click.slick",e.selectHandler),d(window).on("orientationchange.slick.slick-"+e.instanceUid,d.proxy(e.orientationChange,e)),d(window).on("resize.slick.slick-"+e.instanceUid,d.proxy(e.resize,e)),d("[draggable!=true]",e.$slideTrack).on("dragstart",e.preventDefault),d(window).on("load.slick.slick-"+e.instanceUid,e.setPosition),d(e.setPosition)},r.prototype.initUI=function(){var e=this;!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow.show(),e.$nextArrow.show()),!0===e.options.dots&&e.slideCount>e.options.slidesToShow&&e.$dots.show()},r.prototype.keyHandler=function(e){var t=this;e.target.tagName.match("TEXTAREA|INPUT|SELECT")||(37===e.keyCode&&!0===t.options.accessibility?t.changeSlide({data:{message:!0===t.options.rtl?"next":"previous"}}):39===e.keyCode&&!0===t.options.accessibility&&t.changeSlide({data:{message:!0===t.options.rtl?"previous":"next"}}))},r.prototype.lazyLoad=function(){var e,t,i,o=this;function s(e){d("img[data-lazy]",e).each(function(){var e=d(this),t=d(this).attr("data-lazy"),i=d(this).attr("data-srcset"),s=d(this).attr("data-sizes")||o.$slider.attr("data-sizes"),n=document.createElement("img");n.onload=function(){e.animate({opacity:0},100,function(){i&&(e.attr("srcset",i),s&&e.attr("sizes",s)),e.attr("src",t).animate({opacity:1},200,function(){e.removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading")}),o.$slider.trigger("lazyLoaded",[o,e,t])})},n.onerror=function(){e.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),o.$slider.trigger("lazyLoadError",[o,e,t])},n.src=t})}if(!0===o.options.centerMode?i=!0===o.options.infinite?(t=o.currentSlide+(o.options.slidesToShow/2+1))+o.options.slidesToShow+2:(t=Math.max(0,o.currentSlide-(o.options.slidesToShow/2+1)),o.options.slidesToShow/2+1+2+o.currentSlide):(t=o.options.infinite?o.options.slidesToShow+o.currentSlide:o.currentSlide,i=Math.ceil(t+o.options.slidesToShow),!0===o.options.fade&&(0<t&&t--,i<=o.slideCount&&i++)),e=o.$slider.find(".slick-slide").slice(t,i),"anticipated"===o.options.lazyLoad)for(var n=t-1,r=i,a=o.$slider.find(".slick-slide"),l=0;l<o.options.slidesToScroll;l++)n<0&&(n=o.slideCount-1),e=(e=e.add(a.eq(n))).add(a.eq(r)),n--,r++;s(e),o.slideCount<=o.options.slidesToShow?s(o.$slider.find(".slick-slide")):o.currentSlide>=o.slideCount-o.options.slidesToShow?s(o.$slider.find(".slick-cloned").slice(0,o.options.slidesToShow)):0===o.currentSlide&&s(o.$slider.find(".slick-cloned").slice(-1*o.options.slidesToShow))},r.prototype.loadSlider=function(){var e=this;e.setPosition(),e.$slideTrack.css({opacity:1}),e.$slider.removeClass("slick-loading"),e.initUI(),"progressive"===e.options.lazyLoad&&e.progressiveLazyLoad()},r.prototype.next=r.prototype.slickNext=function(){this.changeSlide({data:{message:"next"}})},r.prototype.orientationChange=function(){this.checkResponsive(),this.setPosition()},r.prototype.pause=r.prototype.slickPause=function(){this.autoPlayClear(),this.paused=!0},r.prototype.play=r.prototype.slickPlay=function(){var e=this;e.autoPlay(),e.options.autoplay=!0,e.paused=!1,e.focussed=!1,e.interrupted=!1},r.prototype.postSlide=function(e){var t=this;t.unslicked||(t.$slider.trigger("afterChange",[t,e]),t.animating=!1,t.slideCount>t.options.slidesToShow&&t.setPosition(),t.swipeLeft=null,t.options.autoplay&&t.autoPlay(),!0===t.options.accessibility&&(t.initADA(),t.options.focusOnChange&&d(t.$slides.get(t.currentSlide)).attr("tabindex",0).focus()))},r.prototype.prev=r.prototype.slickPrev=function(){this.changeSlide({data:{message:"previous"}})},r.prototype.preventDefault=function(e){e.preventDefault()},r.prototype.progressiveLazyLoad=function(e){e=e||1;var t,i,s,n,o,r=this,a=d("img[data-lazy]",r.$slider);a.length?(t=a.first(),i=t.attr("data-lazy"),s=t.attr("data-srcset"),n=t.attr("data-sizes")||r.$slider.attr("data-sizes"),(o=document.createElement("img")).onload=function(){s&&(t.attr("srcset",s),n&&t.attr("sizes",n)),t.attr("src",i).removeAttr("data-lazy data-srcset data-sizes").removeClass("slick-loading"),!0===r.options.adaptiveHeight&&r.setPosition(),r.$slider.trigger("lazyLoaded",[r,t,i]),r.progressiveLazyLoad()},o.onerror=function(){e<3?setTimeout(function(){r.progressiveLazyLoad(e+1)},500):(t.removeAttr("data-lazy").removeClass("slick-loading").addClass("slick-lazyload-error"),r.$slider.trigger("lazyLoadError",[r,t,i]),r.progressiveLazyLoad())},o.src=i):r.$slider.trigger("allImagesLoaded",[r])},r.prototype.refresh=function(e){var t,i=this,s=i.slideCount-i.options.slidesToShow;!i.options.infinite&&i.currentSlide>s&&(i.currentSlide=s),i.slideCount<=i.options.slidesToShow&&(i.currentSlide=0),t=i.currentSlide,i.destroy(!0),d.extend(i,i.initials,{currentSlide:t}),i.init(),e||i.changeSlide({data:{message:"index",index:t}},!1)},r.prototype.registerBreakpoints=function(){var e,t,i,s=this,n=s.options.responsive||null;if("array"===d.type(n)&&n.length){for(e in s.respondTo=s.options.respondTo||"window",n)if(i=s.breakpoints.length-1,n.hasOwnProperty(e)){for(t=n[e].breakpoint;0<=i;)s.breakpoints[i]&&s.breakpoints[i]===t&&s.breakpoints.splice(i,1),i--;s.breakpoints.push(t),s.breakpointSettings[t]=n[e].settings}s.breakpoints.sort(function(e,t){return s.options.mobileFirst?e-t:t-e})}},r.prototype.reinit=function(){var e=this;e.$slides=e.$slideTrack.children(e.options.slide).addClass("slick-slide"),e.slideCount=e.$slides.length,e.currentSlide>=e.slideCount&&0!==e.currentSlide&&(e.currentSlide=e.currentSlide-e.options.slidesToScroll),e.slideCount<=e.options.slidesToShow&&(e.currentSlide=0),e.registerBreakpoints(),e.setProps(),e.setupInfinite(),e.buildArrows(),e.updateArrows(),e.initArrowEvents(),e.buildDots(),e.updateDots(),e.initDotEvents(),e.cleanUpSlideEvents(),e.initSlideEvents(),e.checkResponsive(!1,!0),!0===e.options.focusOnSelect&&d(e.$slideTrack).children().on("click.slick",e.selectHandler),e.setSlideClasses("number"==typeof e.currentSlide?e.currentSlide:0),e.setPosition(),e.focusHandler(),e.paused=!e.options.autoplay,e.autoPlay(),e.$slider.trigger("reInit",[e])},r.prototype.resize=function(){var e=this;d(window).width()!==e.windowWidth&&(clearTimeout(e.windowDelay),e.windowDelay=window.setTimeout(function(){e.windowWidth=d(window).width(),e.checkResponsive(),e.unslicked||e.setPosition()},50))},r.prototype.removeSlide=r.prototype.slickRemove=function(e,t,i){var s=this;if(e="boolean"==typeof e?!0===(t=e)?0:s.slideCount-1:!0===t?--e:e,s.slideCount<1||e<0||e>s.slideCount-1)return!1;s.unload(),!0===i?s.$slideTrack.children().remove():s.$slideTrack.children(this.options.slide).eq(e).remove(),s.$slides=s.$slideTrack.children(this.options.slide),s.$slideTrack.children(this.options.slide).detach(),s.$slideTrack.append(s.$slides),s.$slidesCache=s.$slides,s.reinit()},r.prototype.setCSS=function(e){var t,i,s=this,n={};!0===s.options.rtl&&(e=-e),t="left"==s.positionProp?Math.ceil(e)+"px":"0px",i="top"==s.positionProp?Math.ceil(e)+"px":"0px",n[s.positionProp]=e,!1===s.transformsEnabled||(!(n={})===s.cssTransitions?n[s.animType]="translate("+t+", "+i+")":n[s.animType]="translate3d("+t+", "+i+", 0px)"),s.$slideTrack.css(n)},r.prototype.setDimensions=function(){var e=this;!1===e.options.vertical?!0===e.options.centerMode&&e.$list.css({padding:"0px "+e.options.centerPadding}):(e.$list.height(e.$slides.first().outerHeight(!0)*e.options.slidesToShow),!0===e.options.centerMode&&e.$list.css({padding:e.options.centerPadding+" 0px"})),e.listWidth=e.$list.width(),e.listHeight=e.$list.height(),!1===e.options.vertical&&!1===e.options.variableWidth?(e.slideWidth=Math.ceil(e.listWidth/e.options.slidesToShow),e.$slideTrack.width(Math.ceil(e.slideWidth*e.$slideTrack.children(".slick-slide").length))):!0===e.options.variableWidth?e.$slideTrack.width(5e3*e.slideCount):(e.slideWidth=Math.ceil(e.listWidth),e.$slideTrack.height(Math.ceil(e.$slides.first().outerHeight(!0)*e.$slideTrack.children(".slick-slide").length)));var t=e.$slides.first().outerWidth(!0)-e.$slides.first().width();!1===e.options.variableWidth&&e.$slideTrack.children(".slick-slide").width(e.slideWidth-t)},r.prototype.setFade=function(){var i,s=this;s.$slides.each(function(e,t){i=s.slideWidth*e*-1,!0===s.options.rtl?d(t).css({position:"relative",right:i,top:0,zIndex:s.options.zIndex-2,opacity:0}):d(t).css({position:"relative",left:i,top:0,zIndex:s.options.zIndex-2,opacity:0})}),s.$slides.eq(s.currentSlide).css({zIndex:s.options.zIndex-1,opacity:1})},r.prototype.setHeight=function(){var e,t=this;1===t.options.slidesToShow&&!0===t.options.adaptiveHeight&&!1===t.options.vertical&&(e=t.$slides.eq(t.currentSlide).outerHeight(!0),t.$list.css("height",e))},r.prototype.setOption=r.prototype.slickSetOption=function(){var e,t,i,s,n,o=this,r=!1;if("object"===d.type(arguments[0])?(i=arguments[0],r=arguments[1],n="multiple"):"string"===d.type(arguments[0])&&(s=arguments[1],r=arguments[2],"responsive"===(i=arguments[0])&&"array"===d.type(arguments[1])?n="responsive":void 0!==arguments[1]&&(n="single")),"single"===n)o.options[i]=s;else if("multiple"===n)d.each(i,function(e,t){o.options[e]=t});else if("responsive"===n)for(t in s)if("array"!==d.type(o.options.responsive))o.options.responsive=[s[t]];else{for(e=o.options.responsive.length-1;0<=e;)o.options.responsive[e].breakpoint===s[t].breakpoint&&o.options.responsive.splice(e,1),e--;o.options.responsive.push(s[t])}r&&(o.unload(),o.reinit())},r.prototype.setPosition=function(){var e=this;e.setDimensions(),e.setHeight(),!1===e.options.fade?e.setCSS(e.getLeft(e.currentSlide)):e.setFade(),e.$slider.trigger("setPosition",[e])},r.prototype.setProps=function(){var e=this,t=document.body.style;e.positionProp=!0===e.options.vertical?"top":"left","top"===e.positionProp?e.$slider.addClass("slick-vertical"):e.$slider.removeClass("slick-vertical"),void 0===t.WebkitTransition&&void 0===t.MozTransition&&void 0===t.msTransition||!0===e.options.useCSS&&(e.cssTransitions=!0),e.options.fade&&("number"==typeof e.options.zIndex?e.options.zIndex<3&&(e.options.zIndex=3):e.options.zIndex=e.defaults.zIndex),void 0!==t.OTransform&&(e.animType="OTransform",e.transformType="-o-transform",e.transitionType="OTransition",void 0===t.perspectiveProperty&&void 0===t.webkitPerspective&&(e.animType=!1)),void 0!==t.MozTransform&&(e.animType="MozTransform",e.transformType="-moz-transform",e.transitionType="MozTransition",void 0===t.perspectiveProperty&&void 0===t.MozPerspective&&(e.animType=!1)),void 0!==t.webkitTransform&&(e.animType="webkitTransform",e.transformType="-webkit-transform",e.transitionType="webkitTransition",void 0===t.perspectiveProperty&&void 0===t.webkitPerspective&&(e.animType=!1)),void 0!==t.msTransform&&(e.animType="msTransform",e.transformType="-ms-transform",e.transitionType="msTransition",void 0===t.msTransform&&(e.animType=!1)),void 0!==t.transform&&!1!==e.animType&&(e.animType="transform",e.transformType="transform",e.transitionType="transition"),e.transformsEnabled=e.options.useTransform&&null!==e.animType&&!1!==e.animType},r.prototype.setSlideClasses=function(e){var t,i,s,n,o=this,r=o.$slider.find(".slick-slide").removeClass("slick-active slick-center slick-current").attr("aria-hidden","true");o.$slides.eq(e).addClass("slick-current"),!0===o.options.centerMode?(s=o.options.slidesToShow%2==0?1:0,n=Math.floor(o.options.slidesToShow/2),!0===o.options.infinite&&(n<=e&&e<=o.slideCount-1-n?o.$slides.slice(e-n+s,e+n+1).addClass("slick-active").attr("aria-hidden","false"):(t=o.options.slidesToShow+e,r.slice(t-n+1+s,t+n+2).addClass("slick-active").attr("aria-hidden","false")),0===e?r.eq(r.length-1-o.options.slidesToShow).addClass("slick-center"):e===o.slideCount-1&&r.eq(o.options.slidesToShow).addClass("slick-center")),o.$slides.eq(e).addClass("slick-center")):0<=e&&e<=o.slideCount-o.options.slidesToShow?o.$slides.slice(e,e+o.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false"):r.length<=o.options.slidesToShow?r.addClass("slick-active").attr("aria-hidden","false"):(i=o.slideCount%o.options.slidesToShow,t=!0===o.options.infinite?o.options.slidesToShow+e:e,o.options.slidesToShow==o.options.slidesToScroll&&o.slideCount-e<o.options.slidesToShow?r.slice(t-(o.options.slidesToShow-i),t+i).addClass("slick-active").attr("aria-hidden","false"):r.slice(t,t+o.options.slidesToShow).addClass("slick-active").attr("aria-hidden","false")),"ondemand"!==o.options.lazyLoad&&"anticipated"!==o.options.lazyLoad||o.lazyLoad()},r.prototype.setupInfinite=function(){var e,t,i,s=this;if(!0===s.options.fade&&(s.options.centerMode=!1),!0===s.options.infinite&&!1===s.options.fade&&(t=null,s.slideCount>s.options.slidesToShow)){for(i=!0===s.options.centerMode?s.options.slidesToShow+1:s.options.slidesToShow,e=s.slideCount;e>s.slideCount-i;--e)t=e-1,d(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t-s.slideCount).prependTo(s.$slideTrack).addClass("slick-cloned");for(e=0;e<i+s.slideCount;e+=1)t=e,d(s.$slides[t]).clone(!0).attr("id","").attr("data-slick-index",t+s.slideCount).appendTo(s.$slideTrack).addClass("slick-cloned");s.$slideTrack.find(".slick-cloned").find("[id]").each(function(){d(this).attr("id","")})}},r.prototype.interrupt=function(e){e||this.autoPlay(),this.interrupted=e},r.prototype.selectHandler=function(e){var t=d(e.target).is(".slick-slide")?d(e.target):d(e.target).parents(".slick-slide"),i=(i=parseInt(t.attr("data-slick-index")))||0;this.slideCount<=this.options.slidesToShow?this.slideHandler(i,!1,!0):this.slideHandler(i)},r.prototype.slideHandler=function(e,t,i){var s,n,o,r,a,l,d=this;if(t=t||!1,!(!0===d.animating&&!0===d.options.waitForAnimate||!0===d.options.fade&&d.currentSlide===e))if(!1===t&&d.asNavFor(e),s=e,a=d.getLeft(s),r=d.getLeft(d.currentSlide),d.currentLeft=null===d.swipeLeft?r:d.swipeLeft,!1===d.options.infinite&&!1===d.options.centerMode&&(e<0||e>d.getDotCount()*d.options.slidesToScroll))!1===d.options.fade&&(s=d.currentSlide,!0!==i&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(s)}):d.postSlide(s));else if(!1===d.options.infinite&&!0===d.options.centerMode&&(e<0||e>d.slideCount-d.options.slidesToScroll))!1===d.options.fade&&(s=d.currentSlide,!0!==i&&d.slideCount>d.options.slidesToShow?d.animateSlide(r,function(){d.postSlide(s)}):d.postSlide(s));else{if(d.options.autoplay&&clearInterval(d.autoPlayTimer),n=s<0?d.slideCount%d.options.slidesToScroll!=0?d.slideCount-d.slideCount%d.options.slidesToScroll:d.slideCount+s:s>=d.slideCount?d.slideCount%d.options.slidesToScroll!=0?0:s-d.slideCount:s,d.animating=!0,d.$slider.trigger("beforeChange",[d,d.currentSlide,n]),o=d.currentSlide,d.currentSlide=n,d.setSlideClasses(d.currentSlide),d.options.asNavFor&&(l=(l=d.getNavTarget()).slick("getSlick")).slideCount<=l.options.slidesToShow&&l.setSlideClasses(d.currentSlide),d.updateDots(),d.updateArrows(),!0===d.options.fade)return!0!==i?(d.fadeSlideOut(o),d.fadeSlide(n,function(){d.postSlide(n)})):d.postSlide(n),void d.animateHeight();!0!==i&&d.slideCount>d.options.slidesToShow?d.animateSlide(a,function(){d.postSlide(n)}):d.postSlide(n)}},r.prototype.startLoad=function(){var e=this;!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&(e.$prevArrow.hide(),e.$nextArrow.hide()),!0===e.options.dots&&e.slideCount>e.options.slidesToShow&&e.$dots.hide(),e.$slider.addClass("slick-loading")},r.prototype.swipeDirection=function(){var e=this,t=e.touchObject.startX-e.touchObject.curX,i=e.touchObject.startY-e.touchObject.curY,s=Math.atan2(i,t),n=Math.round(180*s/Math.PI);return n<0&&(n=360-Math.abs(n)),n<=45&&0<=n||n<=360&&315<=n?!1===e.options.rtl?"left":"right":135<=n&&n<=225?!1===e.options.rtl?"right":"left":!0===e.options.verticalSwiping?35<=n&&n<=135?"down":"up":"vertical"},r.prototype.swipeEnd=function(e){var t,i,s=this;if(s.dragging=!1,s.swiping=!1,s.scrolling)return s.scrolling=!1;if(s.interrupted=!1,s.shouldClick=!(10<s.touchObject.swipeLength),void 0===s.touchObject.curX)return!1;if(!0===s.touchObject.edgeHit&&s.$slider.trigger("edge",[s,s.swipeDirection()]),s.touchObject.swipeLength>=s.touchObject.minSwipe){switch(i=s.swipeDirection()){case"left":case"down":t=s.options.swipeToSlide?s.checkNavigable(s.currentSlide+s.getSlideCount()):s.currentSlide+s.getSlideCount(),s.currentDirection=0;break;case"right":case"up":t=s.options.swipeToSlide?s.checkNavigable(s.currentSlide-s.getSlideCount()):s.currentSlide-s.getSlideCount(),s.currentDirection=1}"vertical"!=i&&(s.slideHandler(t),s.touchObject={},s.$slider.trigger("swipe",[s,i]))}else s.touchObject.startX!==s.touchObject.curX&&(s.slideHandler(s.currentSlide),s.touchObject={})},r.prototype.swipeHandler=function(e){var t=this;if(!(!1===t.options.swipe||"ontouchend"in document&&!1===t.options.swipe||!1===t.options.draggable&&-1!==e.type.indexOf("mouse")))switch(t.touchObject.fingerCount=e.originalEvent&&void 0!==e.originalEvent.touches?e.originalEvent.touches.length:1,t.touchObject.minSwipe=t.listWidth/t.options.touchThreshold,!0===t.options.verticalSwiping&&(t.touchObject.minSwipe=t.listHeight/t.options.touchThreshold),e.data.action){case"start":t.swipeStart(e);break;case"move":t.swipeMove(e);break;case"end":t.swipeEnd(e)}},r.prototype.swipeMove=function(e){var t,i,s,n,o,r=this,a=void 0!==e.originalEvent?e.originalEvent.touches:null;return!(!r.dragging||r.scrolling||a&&1!==a.length)&&(t=r.getLeft(r.currentSlide),r.touchObject.curX=void 0!==a?a[0].pageX:e.clientX,r.touchObject.curY=void 0!==a?a[0].pageY:e.clientY,r.touchObject.swipeLength=Math.round(Math.sqrt(Math.pow(r.touchObject.curX-r.touchObject.startX,2))),o=Math.round(Math.sqrt(Math.pow(r.touchObject.curY-r.touchObject.startY,2))),!r.options.verticalSwiping&&!r.swiping&&4<o?!(r.scrolling=!0):(!0===r.options.verticalSwiping&&(r.touchObject.swipeLength=o),i=r.swipeDirection(),void 0!==e.originalEvent&&4<r.touchObject.swipeLength&&(r.swiping=!0,e.preventDefault()),n=(!1===r.options.rtl?1:-1)*(r.touchObject.curX>r.touchObject.startX?1:-1),!0===r.options.verticalSwiping&&(n=r.touchObject.curY>r.touchObject.startY?1:-1),s=r.touchObject.swipeLength,(r.touchObject.edgeHit=!1)===r.options.infinite&&(0===r.currentSlide&&"right"===i||r.currentSlide>=r.getDotCount()&&"left"===i)&&(s=r.touchObject.swipeLength*r.options.edgeFriction,r.touchObject.edgeHit=!0),!1===r.options.vertical?r.swipeLeft=t+s*n:r.swipeLeft=t+s*(r.$list.height()/r.listWidth)*n,!0===r.options.verticalSwiping&&(r.swipeLeft=t+s*n),!0!==r.options.fade&&!1!==r.options.touchMove&&(!0===r.animating?(r.swipeLeft=null,!1):void r.setCSS(r.swipeLeft))))},r.prototype.swipeStart=function(e){var t,i=this;if(i.interrupted=!0,1!==i.touchObject.fingerCount||i.slideCount<=i.options.slidesToShow)return!(i.touchObject={});void 0!==e.originalEvent&&void 0!==e.originalEvent.touches&&(t=e.originalEvent.touches[0]),i.touchObject.startX=i.touchObject.curX=void 0!==t?t.pageX:e.clientX,i.touchObject.startY=i.touchObject.curY=void 0!==t?t.pageY:e.clientY,i.dragging=!0},r.prototype.unfilterSlides=r.prototype.slickUnfilter=function(){var e=this;null!==e.$slidesCache&&(e.unload(),e.$slideTrack.children(this.options.slide).detach(),e.$slidesCache.appendTo(e.$slideTrack),e.reinit())},r.prototype.unload=function(){var e=this;d(".slick-cloned",e.$slider).remove(),e.$dots&&e.$dots.remove(),e.$prevArrow&&e.htmlExpr.test(e.options.prevArrow)&&e.$prevArrow.remove(),e.$nextArrow&&e.htmlExpr.test(e.options.nextArrow)&&e.$nextArrow.remove(),e.$slides.removeClass("slick-slide slick-active slick-visible slick-current").attr("aria-hidden","true").css("width","")},r.prototype.unslick=function(e){this.$slider.trigger("unslick",[this,e]),this.destroy()},r.prototype.updateArrows=function(){var e=this;Math.floor(e.options.slidesToShow/2);!0===e.options.arrows&&e.slideCount>e.options.slidesToShow&&!e.options.infinite&&(e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false"),0===e.currentSlide?(e.$prevArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$nextArrow.removeClass("slick-disabled").attr("aria-disabled","false")):(e.currentSlide>=e.slideCount-e.options.slidesToShow&&!1===e.options.centerMode||e.currentSlide>=e.slideCount-1&&!0===e.options.centerMode)&&(e.$nextArrow.addClass("slick-disabled").attr("aria-disabled","true"),e.$prevArrow.removeClass("slick-disabled").attr("aria-disabled","false")))},r.prototype.updateDots=function(){var e=this;null!==e.$dots&&(e.$dots.find("li").removeClass("slick-active").end(),e.$dots.find("li").eq(Math.floor(e.currentSlide/e.options.slidesToScroll)).addClass("slick-active"))},r.prototype.visibility=function(){this.options.autoplay&&(document[this.hidden]?this.interrupted=!0:this.interrupted=!1)},d.fn.slick=function(){for(var e,t=this,i=arguments[0],s=Array.prototype.slice.call(arguments,1),n=t.length,o=0;o<n;o++)if("object"==typeof i||void 0===i?t[o].slick=new r(t[o],i):e=t[o].slick[i].apply(t[o].slick,s),void 0!==e)return e;return t}}),function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t(require("jquery")):"function"==typeof define&&define.amd?define(["jquery"],t):(e=e||self).parsley=t(e.jQuery)}(this,function(u){"use strict";function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function l(){return(l=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(e[s]=i[s])}return e}).apply(this,arguments)}function a(e,t){return function(e){if(Array.isArray(e))return e}(e)||function(e,t){if(!(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e)))return;var i=[],s=!0,n=!1,o=void 0;try{for(var r,a=e[Symbol.iterator]();!(s=(r=a.next()).done)&&(i.push(r.value),!t||i.length!==t);s=!0);}catch(e){n=!0,o=e}finally{try{s||null==a.return||a.return()}finally{if(n)throw o}}return i}(e,t)||function(){throw new TypeError("Invalid attempt to destructure non-iterable instance")}()}function d(e){return function(e){if(Array.isArray(e)){for(var t=0,i=new Array(e.length);t<e.length;t++)i[t]=e[t];return i}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}var e=1,t={},c={attr:function(e,t,i){var s,n,o,r=new RegExp("^"+t,"i");if(void 0===i)i={};else for(s in i)i.hasOwnProperty(s)&&delete i[s];if(!e)return i;for(s=(o=e.attributes).length;s--;)(n=o[s])&&n.specified&&r.test(n.name)&&(i[this.camelize(n.name.slice(t.length))]=this.deserializeValue(n.value));return i},checkAttr:function(e,t,i){return e.hasAttribute(t+i)},setAttr:function(e,t,i,s){e.setAttribute(this.dasherize(t+i),String(s))},getType:function(e){return e.getAttribute("type")||"text"},generateID:function(){return""+e++},deserializeValue:function(t){var e;try{return t?"true"==t||"false"!=t&&("null"==t?null:isNaN(e=Number(t))?/^[\[\{]/.test(t)?JSON.parse(t):t:e):t}catch(e){return t}},camelize:function(e){return e.replace(/-+(.)?/g,function(e,t){return t?t.toUpperCase():""})},dasherize:function(e){return e.replace(/::/g,"/").replace(/([A-Z]+)([A-Z][a-z])/g,"$1_$2").replace(/([a-z\d])([A-Z])/g,"$1_$2").replace(/_/g,"-").toLowerCase()},warn:function(){var e;window.console&&"function"==typeof window.console.warn&&(e=window.console).warn.apply(e,arguments)},warnOnce:function(e){t[e]||(t[e]=!0,this.warn.apply(this,arguments))},_resetWarnings:function(){t={}},trimString:function(e){return e.replace(/^\s+|\s+$/g,"")},parse:{date:function(e){var t=e.match(/^(\d{4,})-(\d\d)-(\d\d)$/);if(!t)return null;var i=a(t.map(function(e){return parseInt(e,10)}),4),s=(i[0],i[1]),n=i[2],o=i[3],r=new Date(s,n-1,o);return r.getFullYear()!==s||r.getMonth()+1!==n||r.getDate()!==o?null:r},string:function(e){return e},integer:function(e){return isNaN(e)?null:parseInt(e,10)},number:function(e){if(isNaN(e))throw null;return parseFloat(e)},boolean:function(e){return!/^\s*false\s*$/i.test(e)},object:function(e){return c.deserializeValue(e)},regexp:function(e){var t="";return e=/^\/.*\/(?:[gimy]*)$/.test(e)?(t=e.replace(/.*\/([gimy]*)$/,"$1"),e.replace(new RegExp("^/(.*?)/"+t+"$"),"$1")):"^"+e+"$",new RegExp(e,t)}},parseRequirement:function(e,t){var i=this.parse[e||"string"];if(!i)throw'Unknown requirement specification: "'+e+'"';var s=i(t);if(null===s)throw"Requirement is not a ".concat(e,': "').concat(t,'"');return s},namespaceEvents:function(e,t){return(e=this.trimString(e||"").split(/\s+/))[0]?u.map(e,function(e){return"".concat(e,".").concat(t)}).join(" "):""},difference:function(e,i){var s=[];return u.each(e,function(e,t){-1==i.indexOf(t)&&s.push(t)}),s},all:function(e){return u.when.apply(u,d(e).concat([42,42]))},objectCreate:Object.create||function(e){if(1<arguments.length)throw Error("Second argument not supported");if("object"!=n(e))throw TypeError("Argument must be an object");i.prototype=e;var t=new i;return i.prototype=null,t},_SubmitSelector:'input[type="submit"], button:submit'};function i(){}function s(){this.__id__=c.generateID()}var o={namespace:"data-parsley-",inputs:"input, textarea, select",excluded:"input[type=button], input[type=submit], input[type=reset], input[type=hidden]",priorityEnabled:!0,multiple:null,group:null,uiEnabled:!0,validationThreshold:3,focus:"first",trigger:!1,triggerAfterFailure:"input",errorClass:"parsley-error",successClass:"parsley-success",classHandler:function(){},errorsContainer:function(){},errorsWrapper:'<ul class="parsley-errors-list"></ul>',errorTemplate:"<li></li>"};s.prototype={asyncSupport:!0,_pipeAccordingToValidationResult:function(){function e(){var e=u.Deferred();return!0!==t.validationResult&&e.reject(),e.resolve().promise()}var t=this;return[e,e]},actualizeOptions:function(){return c.attr(this.element,this.options.namespace,this.domOptions),this.parent&&this.parent.actualizeOptions&&this.parent.actualizeOptions(),this},_resetOptions:function(e){for(var t in this.domOptions=c.objectCreate(this.parent.options),this.options=c.objectCreate(this.domOptions),e)e.hasOwnProperty(t)&&(this.options[t]=e[t]);this.actualizeOptions()},_listeners:null,on:function(e,t){return this._listeners=this._listeners||{},(this._listeners[e]=this._listeners[e]||[]).push(t),this},subscribe:function(e,t){u.listenTo(this,e.toLowerCase(),t)},off:function(e,t){var i=this._listeners&&this._listeners[e];if(i)if(t)for(var s=i.length;s--;)i[s]===t&&i.splice(s,1);else delete this._listeners[e];return this},unsubscribe:function(e){u.unsubscribeTo(this,e.toLowerCase())},trigger:function(e,t,i){t=t||this;var s,n=this._listeners&&this._listeners[e];if(n)for(var o=n.length;o--;)if(!1===(s=n[o].call(t,t,i)))return s;return!this.parent||this.parent.trigger(e,t,i)},asyncIsValid:function(e,t){return c.warnOnce("asyncIsValid is deprecated; please use whenValid instead"),this.whenValid({group:e,force:t})},_findRelated:function(){return this.options.multiple?u(this.parent.element.querySelectorAll("[".concat(this.options.namespace,'multiple="').concat(this.options.multiple,'"]'))):this.$element}};function p(e){u.extend(!0,this,e)}p.prototype={validate:function(e,t){if(this.fn)return 3<arguments.length&&(t=[].slice.call(arguments,1,-1)),this.fn(e,t);if(Array.isArray(e)){if(!this.validateMultiple)throw"Validator `"+this.name+"` does not handle multiple values";return this.validateMultiple.apply(this,arguments)}var i=arguments[arguments.length-1];if(this.validateDate&&i._isDateInput())return arguments[0]=c.parse.date(arguments[0]),null!==arguments[0]&&this.validateDate.apply(this,arguments);if(this.validateNumber)return!e||!isNaN(e)&&(arguments[0]=parseFloat(arguments[0]),this.validateNumber.apply(this,arguments));if(this.validateString)return this.validateString.apply(this,arguments);throw"Validator `"+this.name+"` only handles multiple values"},parseRequirements:function(e,t){if("string"!=typeof e)return Array.isArray(e)?e:[e];var i=this.requirementType;if(Array.isArray(i)){for(var s=function(e,t){var i=e.match(/^\s*\[(.*)\]\s*$/);if(!i)throw'Requirement is not an array: "'+e+'"';var s=i[1].split(",").map(c.trimString);if(s.length!==t)throw"Requirement has "+s.length+" values when "+t+" are needed";return s}(e,i.length),n=0;n<s.length;n++)s[n]=c.parseRequirement(i[n],s[n]);return s}return u.isPlainObject(i)?function(e,t,i){var s,n=null,o={};for(var r in e){r?("string"==typeof(s=i(r))&&(s=c.parseRequirement(e[r],s)),o[r]=s):n=c.parseRequirement(e[r],t)}return[n,o]}(i,e,t):[c.parseRequirement(i,e)]},requirementType:"string",priority:2};function r(e,t){this.__class__="ValidatorRegistry",this.locale="en",this.init(e||{},t||{})}var h={email:/^((([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-zA-Z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-zA-Z]|\d|-|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-zA-Z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))$/,number:/^-?(\d*\.)?\d+(e[-+]?\d+)?$/i,integer:/^-?\d+$/,digits:/^\d+$/,alphanum:/^\w+$/i,date:{test:function(e){return null!==c.parse.date(e)}},url:new RegExp("^(?:(?:https?|ftp)://)?(?:\\S+(?::\\S*)?@)?(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[1-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-zA-Z\\u00a1-\\uffff0-9]-*)*[a-zA-Z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-zA-Z\\u00a1-\\uffff]{2,})))(?::\\d{2,5})?(?:/\\S*)?$")};h.range=h.number;function f(e){var t=(""+e).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);return t?Math.max(0,(t[1]?t[1].length:0)-(t[2]?+t[2]:0)):0}function v(o,r){return function(e){for(var t,i=arguments.length,s=new Array(1<i?i-1:0),n=1;n<i;n++)s[n-1]=arguments[n];return s.pop(),r.apply(void 0,[e].concat(d((t=o,s.map(c.parse[t])))))}}function m(e){return{validateDate:v("date",e),validateNumber:v("number",e),requirementType:e.length<=2?"string":["string","string"],priority:30}}r.prototype={init:function(e,t){for(var i in this.catalog=t,this.validators=l({},this.validators),e)this.addValidator(i,e[i].fn,e[i].priority);window.Parsley.trigger("parsley:validator:init")},setLocale:function(e){if(void 0===this.catalog[e])throw new Error(e+" is not available in the catalog");return this.locale=e,this},addCatalog:function(e,t,i){return"object"===n(t)&&(this.catalog[e]=t),!0===i?this.setLocale(e):this},addMessage:function(e,t,i){return void 0===this.catalog[e]&&(this.catalog[e]={}),this.catalog[e][t]=i,this},addMessages:function(e,t){for(var i in t)this.addMessage(e,i,t[i]);return this},addValidator:function(e,t,i){if(this.validators[e])c.warn('Validator "'+e+'" is already defined.');else if(o.hasOwnProperty(e))return void c.warn('"'+e+'" is a restricted keyword and is not a valid validator name.');return this._setValidator.apply(this,arguments)},hasValidator:function(e){return!!this.validators[e]},updateValidator:function(e,t,i){return this.validators[e]?this._setValidator.apply(this,arguments):(c.warn('Validator "'+e+'" is not already defined.'),this.addValidator.apply(this,arguments))},removeValidator:function(e){return this.validators[e]||c.warn('Validator "'+e+'" is not defined.'),delete this.validators[e],this},_setValidator:function(e,t,i){for(var s in"object"!==n(t)&&(t={fn:t,priority:i}),t.validate||(t=new p(t)),(this.validators[e]=t).messages||{})this.addMessage(s,e,t.messages[s]);return this},getErrorMessage:function(e){return("type"===e.name?(this.catalog[this.locale][e.name]||{})[e.requirements]:this.formatMessage(this.catalog[this.locale][e.name],e.requirements))||this.catalog[this.locale].defaultMessage||this.catalog.en.defaultMessage},formatMessage:function(e,t){if("object"!==n(t))return"string"==typeof e?e.replace(/%s/i,t):"";for(var i in t)e=this.formatMessage(e,t[i]);return e},validators:{notblank:{validateString:function(e){return/\S/.test(e)},priority:2},required:{validateMultiple:function(e){return 0<e.length},validateString:function(e){return/\S/.test(e)},priority:512},type:{validateString:function(e,t,i){var s=2<arguments.length&&void 0!==i?i:{},n=s.step,o=void 0===n?"any":n,r=s.base,a=void 0===r?0:r,l=h[t];if(!l)throw new Error("validator type `"+t+"` is not supported");if(!e)return!0;if(!l.test(e))return!1;if("number"===t&&!/^any$/i.test(o||"")){var d=Number(e),c=Math.max(f(o),f(a));if(f(d)>c)return!1;var u=function(e){return Math.round(e*Math.pow(10,c))};if((u(d)-u(a))%u(o)!=0)return!1}return!0},requirementType:{"":"string",step:"string",base:"number"},priority:256},pattern:{validateString:function(e,t){return!e||t.test(e)},requirementType:"regexp",priority:64},minlength:{validateString:function(e,t){return!e||e.length>=t},requirementType:"integer",priority:30},maxlength:{validateString:function(e,t){return e.length<=t},requirementType:"integer",priority:30},length:{validateString:function(e,t,i){return!e||e.length>=t&&e.length<=i},requirementType:["integer","integer"],priority:30},mincheck:{validateMultiple:function(e,t){return e.length>=t},requirementType:"integer",priority:30},maxcheck:{validateMultiple:function(e,t){return e.length<=t},requirementType:"integer",priority:30},check:{validateMultiple:function(e,t,i){return e.length>=t&&e.length<=i},requirementType:["integer","integer"],priority:30},min:m(function(e,t){return t<=e}),max:m(function(e,t){return e<=t}),range:m(function(e,t,i){return t<=e&&e<=i}),equalto:{validateString:function(e,t){if(!e)return!0;var i=u(t);return i.length?e===i.val():e===t},priority:256},euvatin:{validateString:function(e){if(!e)return!0;return/^[A-Z][A-Z][A-Za-z0-9 -]{2,}$/.test(e)},priority:30}}};var g={};g.Form={_actualizeTriggers:function(){var t=this;this.$element.on("submit.Parsley",function(e){t.onSubmitValidate(e)}),this.$element.on("click.Parsley",c._SubmitSelector,function(e){t.onSubmitButton(e)}),!1!==this.options.uiEnabled&&this.element.setAttribute("novalidate","")},focus:function(){if(!(this._focusedField=null)===this.validationResult||"none"===this.options.focus)return null;for(var e=0;e<this.fields.length;e++){var t=this.fields[e];if(!0!==t.validationResult&&0<t.validationResult.length&&void 0===t.options.noFocus&&(this._focusedField=t.$element,"first"===this.options.focus))break}return null===this._focusedField?null:this._focusedField.focus()},_destroyUI:function(){this.$element.off(".Parsley")}},g.Field={_reflowUI:function(){var e;this._buildUI(),this._ui&&(e=function e(t,i,s){for(var n=[],o=[],r=0;r<t.length;r++){for(var a=!1,l=0;l<i.length;l++)if(t[r].assert.name===i[l].assert.name){a=!0;break}a?o.push(t[r]):n.push(t[r])}return{kept:o,added:n,removed:s?[]:e(i,t,!0).added}}(this.validationResult,this._ui.lastValidationResult),this._ui.lastValidationResult=this.validationResult,this._manageStatusClass(),this._manageErrorsMessages(e),this._actualizeTriggers(),!e.kept.length&&!e.added.length||this._failedOnce||(this._failedOnce=!0,this._actualizeTriggers()))},getErrorsMessages:function(){if(!0===this.validationResult)return[];for(var e=[],t=0;t<this.validationResult.length;t++)e.push(this.validationResult[t].errorMessage||this._getErrorMessage(this.validationResult[t].assert));return e},addError:function(e,t){var i=1<arguments.length&&void 0!==t?t:{},s=i.message,n=i.assert,o=i.updateClass,r=void 0===o||o;this._buildUI(),this._addError(e,{message:s,assert:n}),r&&this._errorClass()},updateError:function(e,t){var i=1<arguments.length&&void 0!==t?t:{},s=i.message,n=i.assert,o=i.updateClass,r=void 0===o||o;this._buildUI(),this._updateError(e,{message:s,assert:n}),r&&this._errorClass()},removeError:function(e,t){var i=(1<arguments.length&&void 0!==t?t:{}).updateClass,s=void 0===i||i;this._buildUI(),this._removeError(e),s&&this._manageStatusClass()},_manageStatusClass:function(){this.hasConstraints()&&this.needsValidation()&&!0===this.validationResult?this._successClass():0<this.validationResult.length?this._errorClass():this._resetClass()},_manageErrorsMessages:function(e){if(void 0===this.options.errorsMessagesDisabled){if(void 0!==this.options.errorMessage)return e.added.length||e.kept.length?(this._insertErrorWrapper(),0===this._ui.$errorsWrapper.find(".parsley-custom-error-message").length&&this._ui.$errorsWrapper.append(u(this.options.errorTemplate).addClass("parsley-custom-error-message")),this._ui.$errorClassHandler.attr("aria-describedby",this._ui.errorsWrapperId),this._ui.$errorsWrapper.addClass("filled").attr("aria-hidden","false").find(".parsley-custom-error-message").html(this.options.errorMessage)):(this._ui.$errorClassHandler.removeAttr("aria-describedby"),this._ui.$errorsWrapper.removeClass("filled").attr("aria-hidden","true").find(".parsley-custom-error-message").remove());for(var t=0;t<e.removed.length;t++)this._removeError(e.removed[t].assert.name);for(t=0;t<e.added.length;t++)this._addError(e.added[t].assert.name,{message:e.added[t].errorMessage,assert:e.added[t].assert});for(t=0;t<e.kept.length;t++)this._updateError(e.kept[t].assert.name,{message:e.kept[t].errorMessage,assert:e.kept[t].assert})}},_addError:function(e,t){var i=t.message,s=t.assert;this._insertErrorWrapper(),this._ui.$errorClassHandler.attr("aria-describedby",this._ui.errorsWrapperId),this._ui.$errorsWrapper.addClass("filled").attr("aria-hidden","false").append(u(this.options.errorTemplate).addClass("parsley-"+e).html(i||this._getErrorMessage(s)))},_updateError:function(e,t){var i=t.message,s=t.assert;this._ui.$errorsWrapper.addClass("filled").find(".parsley-"+e).html(i||this._getErrorMessage(s))},_removeError:function(e){this._ui.$errorClassHandler.removeAttr("aria-describedby"),this._ui.$errorsWrapper.removeClass("filled").attr("aria-hidden","true").find(".parsley-"+e).remove()},_getErrorMessage:function(e){var t=e.name+"Message";return void 0!==this.options[t]?window.Parsley.formatMessage(this.options[t],e.requirements):window.Parsley.getErrorMessage(e)},_buildUI:function(){var e;this._ui||!1===this.options.uiEnabled||(e={},this.element.setAttribute(this.options.namespace+"id",this.__id__),e.$errorClassHandler=this._manageClassHandler(),e.errorsWrapperId="parsley-id-"+(this.options.multiple?"multiple-"+this.options.multiple:this.__id__),e.$errorsWrapper=u(this.options.errorsWrapper).attr("id",e.errorsWrapperId),e.lastValidationResult=[],e.validationInformationVisible=!1,this._ui=e)},_manageClassHandler:function(){if("string"==typeof this.options.classHandler&&u(this.options.classHandler).length)return u(this.options.classHandler);var e=this.options.classHandler;if("string"==typeof this.options.classHandler&&"function"==typeof window[this.options.classHandler]&&(e=window[this.options.classHandler]),"function"==typeof e){var t=e.call(this,this);if(void 0!==t&&t.length)return t}else{if("object"===n(e)&&e instanceof jQuery&&e.length)return e;e&&c.warn("The class handler `"+e+"` does not exist in DOM nor as a global JS function")}return this._inputHolder()},_inputHolder:function(){return this.options.multiple&&"SELECT"!==this.element.nodeName?this.$element.parent():this.$element},_insertErrorWrapper:function(){var e=this.options.errorsContainer;if(0!==this._ui.$errorsWrapper.parent().length)return this._ui.$errorsWrapper.parent();if("string"==typeof e){if(u(e).length)return u(e).append(this._ui.$errorsWrapper);"function"==typeof window[e]?e=window[e]:c.warn("The errors container `"+e+"` does not exist in DOM nor as a global JS function")}return"function"==typeof e&&(e=e.call(this,this)),"object"===n(e)&&e.length?e.append(this._ui.$errorsWrapper):this._inputHolder().after(this._ui.$errorsWrapper)},_actualizeTriggers:function(){var e,t=this,i=this._findRelated();i.off(".Parsley"),this._failedOnce?i.on(c.namespaceEvents(this.options.triggerAfterFailure,"Parsley"),function(){t._validateIfNeeded()}):(e=c.namespaceEvents(this.options.trigger,"Parsley"))&&i.on(e,function(e){t._validateIfNeeded(e)})},_validateIfNeeded:function(e){var t=this;e&&/key|input/.test(e.type)&&(!this._ui||!this._ui.validationInformationVisible)&&this.getValue().length<=this.options.validationThreshold||(this.options.debounce?(window.clearTimeout(this._debounced),this._debounced=window.setTimeout(function(){return t.validate()},this.options.debounce)):this.validate())},_resetUI:function(){this._failedOnce=!1,this._actualizeTriggers(),void 0!==this._ui&&(this._ui.$errorsWrapper.removeClass("filled").children().remove(),this._resetClass(),this._ui.lastValidationResult=[],this._ui.validationInformationVisible=!1)},_destroyUI:function(){this._resetUI(),void 0!==this._ui&&this._ui.$errorsWrapper.remove(),delete this._ui},_successClass:function(){this._ui.validationInformationVisible=!0,this._ui.$errorClassHandler.removeClass(this.options.errorClass).addClass(this.options.successClass)},_errorClass:function(){this._ui.validationInformationVisible=!0,this._ui.$errorClassHandler.removeClass(this.options.successClass).addClass(this.options.errorClass)},_resetClass:function(){this._ui.$errorClassHandler.removeClass(this.options.successClass).removeClass(this.options.errorClass)}};function y(e,t,i){this.__class__="Form",this.element=e,this.$element=u(e),this.domOptions=t,this.options=i,this.parent=window.Parsley,this.fields=[],this.validationResult=null}var w={pending:null,resolved:!0,rejected:!1};y.prototype={onSubmitValidate:function(e){var t,i,s=this;!0!==e.parsley&&(t=this._submitSource||this.$element.find(c._SubmitSelector)[0],this._submitSource=null,this.$element.find(".parsley-synthetic-submit-button").prop("disabled",!0),t&&null!==t.getAttribute("formnovalidate")||(window.Parsley._remoteCache={},"resolved"===(i=this.whenValidate({event:e})).state()&&!1!==this._trigger("submit")||(e.stopImmediatePropagation(),e.preventDefault(),"pending"===i.state()&&i.done(function(){s._submit(t)}))))},onSubmitButton:function(e){this._submitSource=e.currentTarget},_submit:function(e){var t;!1!==this._trigger("submit")&&(e&&(0===(t=this.$element.find(".parsley-synthetic-submit-button").prop("disabled",!1)).length&&(t=u('<input class="parsley-synthetic-submit-button" type="hidden">').appendTo(this.$element)),t.attr({name:e.getAttribute("name"),value:e.getAttribute("value")})),this.$element.trigger(l(u.Event("submit"),{parsley:!0})))},validate:function(e){var t;return 1<=arguments.length&&!u.isPlainObject(e)&&(c.warnOnce("Calling validate on a parsley form without passing arguments as an object is deprecated."),e={group:(t=Array.prototype.slice.call(arguments))[0],force:t[1],event:t[2]}),w[this.whenValidate(e).state()]},whenValidate:function(e){var t,i=this,s=0<arguments.length&&void 0!==e?e:{},n=s.group,o=s.force,r=s.event;(this.submitEvent=r)&&(this.submitEvent=l({},r,{preventDefault:function(){c.warnOnce("Using `this.submitEvent.preventDefault()` is deprecated; instead, call `this.validationResult = false`"),i.validationResult=!1}})),this.validationResult=!0,this._trigger("validate"),this._refreshFields();var a=this._withoutReactualizingFormOptions(function(){return u.map(i.fields,function(e){return e.whenValidate({force:o,group:n})})});return(t=c.all(a).done(function(){i._trigger("success")}).fail(function(){i.validationResult=!1,i.focus(),i._trigger("error")}).always(function(){i._trigger("validated")})).pipe.apply(t,d(this._pipeAccordingToValidationResult()))},isValid:function(e){var t;return 1<=arguments.length&&!u.isPlainObject(e)&&(c.warnOnce("Calling isValid on a parsley form without passing arguments as an object is deprecated."),e={group:(t=Array.prototype.slice.call(arguments))[0],force:t[1]}),w[this.whenValid(e).state()]},whenValid:function(e){var t=this,i=0<arguments.length&&void 0!==e?e:{},s=i.group,n=i.force;this._refreshFields();var o=this._withoutReactualizingFormOptions(function(){return u.map(t.fields,function(e){return e.whenValid({group:s,force:n})})});return c.all(o)},refresh:function(){return this._refreshFields(),this},reset:function(){for(var e=0;e<this.fields.length;e++)this.fields[e].reset();this._trigger("reset")},destroy:function(){this._destroyUI();for(var e=0;e<this.fields.length;e++)this.fields[e].destroy();this.$element.removeData("Parsley"),this._trigger("destroy")},_refreshFields:function(){return this.actualizeOptions()._bindFields()},_bindFields:function(){var n=this,e=this.fields;return this.fields=[],this.fieldsMappedById={},this._withoutReactualizingFormOptions(function(){n.$element.find(n.options.inputs).not(n.options.excluded).not("[".concat(n.options.namespace,"excluded=true]")).each(function(e,t){var i,s=new window.Parsley.Factory(t,{},n);"Field"!==s.__class__&&"FieldMultiple"!==s.__class__||(i=s.__class__+"-"+s.__id__,void 0===n.fieldsMappedById[i]&&(n.fieldsMappedById[i]=s,n.fields.push(s)))}),u.each(c.difference(e,n.fields),function(e,t){t.reset()})}),this},_withoutReactualizingFormOptions:function(e){var t=this.actualizeOptions;this.actualizeOptions=function(){return this};var i=e();return this.actualizeOptions=t,i},_trigger:function(e){return this.trigger("form:"+e)}};function b(e,t,i,s,n){var o=window.Parsley._validatorRegistry.validators[t],r=new p(o);l(this,{validator:r,name:t,requirements:i,priority:s=s||e.options[t+"Priority"]||r.priority,isDomConstraint:n=!0===n}),this._parseRequirements(e.options)}function k(e,t,i,s){this.__class__="Field",this.element=e,this.$element=u(e),void 0!==s&&(this.parent=s),this.options=i,this.domOptions=t,this.constraints=[],this.constraintsByName={},this.validationResult=!0,this._bindConstraints()}var T={pending:null,resolved:!0,rejected:!(b.prototype={validate:function(e,t){var i;return(i=this.validator).validate.apply(i,[e].concat(d(this.requirementList),[t]))},_parseRequirements:function(i){var s=this;this.requirementList=this.validator.parseRequirements(this.requirements,function(e){return i[s.name+((t=e)[0].toUpperCase()+t.slice(1))];var t})}})};k.prototype={validate:function(e){1<=arguments.length&&!u.isPlainObject(e)&&(c.warnOnce("Calling validate on a parsley field without passing arguments as an object is deprecated."),e={options:e});var t=this.whenValidate(e);if(!t)return!0;switch(t.state()){case"pending":return null;case"resolved":return!0;case"rejected":return this.validationResult}},whenValidate:function(e){var t,i=this,s=0<arguments.length&&void 0!==e?e:{},n=s.force,o=s.group;if(this.refresh(),!o||this._isInGroup(o))return this.value=this.getValue(),this._trigger("validate"),(t=this.whenValid({force:n,value:this.value,_refreshed:!0}).always(function(){i._reflowUI()}).done(function(){i._trigger("success")}).fail(function(){i._trigger("error")}).always(function(){i._trigger("validated")})).pipe.apply(t,d(this._pipeAccordingToValidationResult()))},hasConstraints:function(){return 0!==this.constraints.length},needsValidation:function(e){return void 0===e&&(e=this.getValue()),!(!e.length&&!this._isRequired()&&void 0===this.options.validateIfEmpty)},_isInGroup:function(e){return Array.isArray(this.options.group)?-1!==u.inArray(e,this.options.group):this.options.group===e},isValid:function(e){var t;1<=arguments.length&&!u.isPlainObject(e)&&(c.warnOnce("Calling isValid on a parsley field without passing arguments as an object is deprecated."),e={force:(t=Array.prototype.slice.call(arguments))[0],value:t[1]});var i=this.whenValid(e);return!i||T[i.state()]},whenValid:function(e){var s=this,t=0<arguments.length&&void 0!==e?e:{},i=t.force,n=void 0!==i&&i,o=t.value,r=t.group;if(t._refreshed||this.refresh(),!r||this._isInGroup(r)){if(this.validationResult=!0,!this.hasConstraints())return u.when();if(null==o&&(o=this.getValue()),!this.needsValidation(o)&&!0!==n)return u.when();var a=this._getGroupedConstraints(),l=[];return u.each(a,function(e,t){var i=c.all(u.map(t,function(e){return s._validateConstraint(o,e)}));if(l.push(i),"rejected"===i.state())return!1}),c.all(l)}},_validateConstraint:function(e,t){var i=this,s=t.validate(e,this);return!1===s&&(s=u.Deferred().reject()),c.all([s]).fail(function(e){i.validationResult instanceof Array||(i.validationResult=[]),i.validationResult.push({assert:t,errorMessage:"string"==typeof e&&e})})},getValue:function(){var e="function"==typeof this.options.value?this.options.value(this):void 0!==this.options.value?this.options.value:this.$element.val();return null==e?"":this._handleWhitespace(e)},reset:function(){return this._resetUI(),this._trigger("reset")},destroy:function(){this._destroyUI(),this.$element.removeData("Parsley"),this.$element.removeData("FieldMultiple"),this._trigger("destroy")},refresh:function(){return this._refreshConstraints(),this},_refreshConstraints:function(){return this.actualizeOptions()._bindConstraints()},refreshConstraints:function(){return c.warnOnce("Parsley's refreshConstraints is deprecated. Please use refresh"),this.refresh()},addConstraint:function(e,t,i,s){var n;return window.Parsley._validatorRegistry.validators[e]&&(n=new b(this,e,t,i,s),"undefined"!==this.constraintsByName[n.name]&&this.removeConstraint(n.name),this.constraints.push(n),this.constraintsByName[n.name]=n),this},removeConstraint:function(e){for(var t=0;t<this.constraints.length;t++)if(e===this.constraints[t].name){this.constraints.splice(t,1);break}return delete this.constraintsByName[e],this},updateConstraint:function(e,t,i){return this.removeConstraint(e).addConstraint(e,t,i)},_bindConstraints:function(){for(var e=[],t={},i=0;i<this.constraints.length;i++)!1===this.constraints[i].isDomConstraint&&(e.push(this.constraints[i]),t[this.constraints[i].name]=this.constraints[i]);for(var s in this.constraints=e,this.constraintsByName=t,this.options)this.addConstraint(s,this.options[s],void 0,!0);return this._bindHtml5Constraints()},_bindHtml5Constraints:function(){null!==this.element.getAttribute("required")&&this.addConstraint("required",!0,void 0,!0),null!==this.element.getAttribute("pattern")&&this.addConstraint("pattern",this.element.getAttribute("pattern"),void 0,!0);var e=this.element.getAttribute("min"),t=this.element.getAttribute("max");null!==e&&null!==t?this.addConstraint("range",[e,t],void 0,!0):null!==e?this.addConstraint("min",e,void 0,!0):null!==t&&this.addConstraint("max",t,void 0,!0),null!==this.element.getAttribute("minlength")&&null!==this.element.getAttribute("maxlength")?this.addConstraint("length",[this.element.getAttribute("minlength"),this.element.getAttribute("maxlength")],void 0,!0):null!==this.element.getAttribute("minlength")?this.addConstraint("minlength",this.element.getAttribute("minlength"),void 0,!0):null!==this.element.getAttribute("maxlength")&&this.addConstraint("maxlength",this.element.getAttribute("maxlength"),void 0,!0);var i=c.getType(this.element);return"number"===i?this.addConstraint("type",["number",{step:this.element.getAttribute("step")||"1",base:e||this.element.getAttribute("value")}],void 0,!0):/^(email|url|range|date)$/i.test(i)?this.addConstraint("type",i,void 0,!0):this},_isRequired:function(){return void 0!==this.constraintsByName.required&&!1!==this.constraintsByName.required.requirements},_trigger:function(e){return this.trigger("field:"+e)},_handleWhitespace:function(e){return!0===this.options.trimValue&&c.warnOnce('data-parsley-trim-value="true" is deprecated, please use data-parsley-whitespace="trim"'),"squish"===this.options.whitespace&&(e=e.replace(/\s{2,}/g," ")),"trim"!==this.options.whitespace&&"squish"!==this.options.whitespace&&!0!==this.options.trimValue||(e=c.trimString(e)),e},_isDateInput:function(){var e=this.constraintsByName.type;return e&&"date"===e.requirements},_getGroupedConstraints:function(){if(!1===this.options.priorityEnabled)return[this.constraints];for(var e=[],t={},i=0;i<this.constraints.length;i++){var s=this.constraints[i].priority;t[s]||e.push(t[s]=[]),t[s].push(this.constraints[i])}return e.sort(function(e,t){return t[0].priority-e[0].priority}),e}};function S(){this.__class__="FieldMultiple"}S.prototype={addElement:function(e){return this.$elements.push(e),this},_refreshConstraints:function(){var e;if(this.constraints=[],"SELECT"===this.element.nodeName)return this.actualizeOptions()._bindConstraints(),this;for(var t=0;t<this.$elements.length;t++)if(u("html").has(this.$elements[t]).length){e=this.$elements[t].data("FieldMultiple")._refreshConstraints().constraints;for(var i=0;i<e.length;i++)this.addConstraint(e[i].name,e[i].requirements,e[i].priority,e[i].isDomConstraint)}else this.$elements.splice(t,1);return this},getValue:function(){if("function"==typeof this.options.value)return this.options.value(this);if(void 0!==this.options.value)return this.options.value;if("INPUT"===this.element.nodeName){var e=c.getType(this.element);if("radio"===e)return this._findRelated().filter(":checked").val()||"";if("checkbox"===e){var t=[];return this._findRelated().filter(":checked").each(function(){t.push(u(this).val())}),t}}return"SELECT"===this.element.nodeName&&null===this.$element.val()?[]:this.$element.val()},_init:function(){return this.$elements=[this.$element],this}};function C(e,t,i){this.element=e,this.$element=u(e);var s=this.$element.data("Parsley");if(s)return void 0!==i&&s.parent===window.Parsley&&(s.parent=i,s._resetOptions(s.options)),"object"===n(t)&&l(s.options,t),s;if(!this.$element.length)throw new Error("You must bind Parsley on an existing element.");if(void 0!==i&&"Form"!==i.__class__)throw new Error("Parent instance must be a Form instance");return this.parent=i||window.Parsley,this.init(t)}C.prototype={init:function(e){return this.__class__="Parsley",this.__version__="2.9.2",this.__id__=c.generateID(),this._resetOptions(e),"FORM"===this.element.nodeName||c.checkAttr(this.element,this.options.namespace,"validate")&&!this.$element.is(this.options.inputs)?this.bind("parsleyForm"):this.isMultiple()?this.handleMultiple():this.bind("parsleyField")},isMultiple:function(){var e=c.getType(this.element);return"radio"===e||"checkbox"===e||"SELECT"===this.element.nodeName&&null!==this.element.getAttribute("multiple")},handleMultiple:function(){var e,t,s=this;if(this.options.multiple=this.options.multiple||(e=this.element.getAttribute("name"))||this.element.getAttribute("id"),"SELECT"===this.element.nodeName&&null!==this.element.getAttribute("multiple"))return this.options.multiple=this.options.multiple||this.__id__,this.bind("parsleyFieldMultiple");if(!this.options.multiple)return c.warn("To be bound by Parsley, a radio, a checkbox and a multiple select input must have either a name or a multiple option.",this.$element),this;this.options.multiple=this.options.multiple.replace(/(:|\.|\[|\]|\{|\}|\$)/g,""),e&&u('input[name="'+e+'"]').each(function(e,t){var i=c.getType(t);"radio"!==i&&"checkbox"!==i||t.setAttribute(s.options.namespace+"multiple",s.options.multiple)});for(var i=this._findRelated(),n=0;n<i.length;n++)if(void 0!==(t=u(i.get(n)).data("Parsley"))){this.$element.data("FieldMultiple")||t.addElement(this.$element);break}return this.bind("parsleyField",!0),t||this.bind("parsleyFieldMultiple")},bind:function(e,t){var i;switch(e){case"parsleyForm":i=u.extend(new y(this.element,this.domOptions,this.options),new s,window.ParsleyExtend)._bindFields();break;case"parsleyField":i=u.extend(new k(this.element,this.domOptions,this.options,this.parent),new s,window.ParsleyExtend);break;case"parsleyFieldMultiple":i=u.extend(new k(this.element,this.domOptions,this.options,this.parent),new S,new s,window.ParsleyExtend)._init();break;default:throw new Error(e+"is not a supported Parsley type")}return this.options.multiple&&c.setAttr(this.element,this.options.namespace,"multiple",this.options.multiple),void 0!==t?this.$element.data("FieldMultiple",i):(this.$element.data("Parsley",i),i._actualizeTriggers(),i._trigger("init")),i}};var $=u.fn.jquery.split(".");if(parseInt($[0])<=1&&parseInt($[1])<8)throw"The loaded version of jQuery is too old. Please upgrade to 1.8.x or better.";$.forEach||c.warn("Parsley requires ES5 to run properly. Please include https://github.com/es-shims/es5-shim");var _=l(new s,{element:document,$element:u(document),actualizeOptions:null,_resetOptions:null,Factory:C,version:"2.9.2"});l(k.prototype,g.Field,s.prototype),l(y.prototype,g.Form,s.prototype),l(C.prototype,s.prototype),u.fn.parsley=u.fn.psly=function(e){if(1<this.length){var t=[];return this.each(function(){t.push(u(this).parsley(e))}),t}if(0!=this.length)return new C(this[0],e)},void 0===window.ParsleyExtend&&(window.ParsleyExtend={}),_.options=l(c.objectCreate(o),window.ParsleyConfig),window.ParsleyConfig=_.options,(window.Parsley=window.psly=_).Utils=c,window.ParsleyUtils={},u.each(c,function(e,t){"function"==typeof t&&(window.ParsleyUtils[e]=function(){return c.warnOnce("Accessing `window.ParsleyUtils` is deprecated. Use `window.Parsley.Utils` instead."),c[e].apply(c,arguments)})});var x=window.Parsley._validatorRegistry=new r(window.ParsleyConfig.validators,window.ParsleyConfig.i18n);window.ParsleyValidator={},u.each("setLocale addCatalog addMessage addMessages getErrorMessage formatMessage addValidator updateValidator removeValidator hasValidator".split(" "),function(e,t){window.Parsley[t]=function(){return x[t].apply(x,arguments)},window.ParsleyValidator[t]=function(){var e;return c.warnOnce("Accessing the method '".concat(t,"' through Validator is deprecated. Simply call 'window.Parsley.").concat(t,"(...)'")),(e=window.Parsley)[t].apply(e,arguments)}}),window.Parsley.UI=g,window.ParsleyUI={removeError:function(e,t,i){var s=!0!==i;return c.warnOnce("Accessing UI is deprecated. Call 'removeError' on the instance directly. Please comment in issue 1073 as to your need to call this method."),e.removeError(t,{updateClass:s})},getErrorsMessages:function(e){return c.warnOnce("Accessing UI is deprecated. Call 'getErrorsMessages' on the instance directly."),e.getErrorsMessages()}},u.each("addError updateError".split(" "),function(e,r){window.ParsleyUI[r]=function(e,t,i,s,n){var o=!0!==n;return c.warnOnce("Accessing UI is deprecated. Call '".concat(r,"' on the instance directly. Please comment in issue 1073 as to your need to call this method.")),e[r](t,{message:i,assert:s,updateClass:o})}}),!1!==window.ParsleyConfig.autoBind&&u(function(){u("[data-parsley-validate]").length&&u("[data-parsley-validate]").parsley()});function A(){c.warnOnce("Parsley's pubsub module is deprecated; use the 'on' and 'off' methods on parsley instances or window.Parsley")}var O=u({});function E(t,i){return t.parsleyAdaptedCallback||(t.parsleyAdaptedCallback=function(){var e=Array.prototype.slice.call(arguments,0);e.unshift(this),t.apply(i||O,e)}),t.parsleyAdaptedCallback}var F="parsley:";function P(e){return 0===e.lastIndexOf(F,0)?e.substr(F.length):e}return u.listen=function(e,t){var i;if(A(),"object"===n(arguments[1])&&"function"==typeof arguments[2]&&(i=arguments[1],t=arguments[2]),"function"!=typeof t)throw new Error("Wrong parameters");window.Parsley.on(P(e),E(t,i))},u.listenTo=function(e,t,i){if(A(),!(e instanceof k||e instanceof y))throw new Error("Must give Parsley instance");if("string"!=typeof t||"function"!=typeof i)throw new Error("Wrong parameters");e.on(P(t),E(i))},u.unsubscribe=function(e,t){if(A(),"string"!=typeof e||"function"!=typeof t)throw new Error("Wrong arguments");window.Parsley.off(P(e),t.parsleyAdaptedCallback)},u.unsubscribeTo=function(e,t){if(A(),!(e instanceof k||e instanceof y))throw new Error("Must give Parsley instance");e.off(P(t))},u.unsubscribeAll=function(t){A(),window.Parsley.off(P(t)),u("form,input,textarea,select").each(function(){var e=u(this).data("Parsley");e&&e.off(P(t))})},u.emit=function(e,t){A();var i=t instanceof k||t instanceof y,s=Array.prototype.slice.call(arguments,i?2:1);s.unshift(P(e)),i||(t=window.Parsley),t.trigger.apply(t,d(s))},u.extend(!0,_,{asyncValidators:{default:{fn:function(e){return 200<=e.status&&e.status<300},url:!1},reverse:{fn:function(e){return e.status<200||300<=e.status},url:!1}},addAsyncValidator:function(e,t,i,s){return _.asyncValidators[e]={fn:t,url:i||!1,options:s||{}},this}}),_.addValidator("remote",{requirementType:{"":"string",validator:"string",reverse:"boolean",options:"object"},validateString:function(e,t,i,s){var n,o={},r=i.validator||(!0===i.reverse?"reverse":"default");if(void 0===_.asyncValidators[r])throw new Error("Calling an undefined async validator: `"+r+"`");-1<(t=_.asyncValidators[r].url||t).indexOf("{value}")?t=t.replace("{value}",encodeURIComponent(e)):o[s.element.getAttribute("name")||s.element.getAttribute("id")]=e;var a=u.extend(!0,i.options||{},_.asyncValidators[r].options),l=u.extend(!0,{},{url:t,data:o,type:"GET"},a);s.trigger("field:ajaxoptions",s,l),n=u.param(l),void 0===_._remoteCache&&(_._remoteCache={});function d(){var e=(e=_.asyncValidators[r].fn.call(s,c,t,i))||u.Deferred().reject();return u.when(e)}var c=_._remoteCache[n]=_._remoteCache[n]||u.ajax(l);return c.then(d,d)},priority:-1}),_.on("form:submit",function(){_._remoteCache={}}),s.prototype.addAsyncValidator=function(){return c.warnOnce("Accessing the method `addAsyncValidator` through an instance is deprecated. Simply call `Parsley.addAsyncValidator(...)`"),_.addAsyncValidator.apply(_,arguments)},_.addMessages("en",{defaultMessage:"This value seems to be invalid.",type:{email:"This value should be a valid email.",url:"This value should be a valid url.",number:"This value should be a valid number.",integer:"This value should be a valid integer.",digits:"This value should be digits.",alphanum:"This value should be alphanumeric."},notblank:"This value should not be blank.",required:"This value is required.",pattern:"This value seems to be invalid.",min:"This value should be greater than or equal to %s.",max:"This value should be lower than or equal to %s.",range:"This value should be between %s and %s.",minlength:"This value is too short. It should have %s characters or more.",maxlength:"This value is too long. It should have %s characters or fewer.",length:"This value length is invalid. It should be between %s and %s characters long.",mincheck:"You must select at least %s choices.",maxcheck:"You must select %s choices or fewer.",check:"You must select between %s and %s choices.",equalto:"This value should be the same.",euvatin:"It's not a valid VAT Identification Number."}),_.setLocale("en"),(new function(){var s=this,n=window||global;l(this,{isNativeEvent:function(e){return e.originalEvent&&!1!==e.originalEvent.isTrusted},fakeInputEvent:function(e){s.isNativeEvent(e)&&u(e.target).trigger("input")},misbehaves:function(e){s.isNativeEvent(e)&&(s.behavesOk(e),u(document).on("change.inputevent",e.data.selector,s.fakeInputEvent),s.fakeInputEvent(e))},behavesOk:function(e){s.isNativeEvent(e)&&u(document).off("input.inputevent",e.data.selector,s.behavesOk).off("change.inputevent",e.data.selector,s.misbehaves)},install:function(){if(!n.inputEventPatched){n.inputEventPatched="0.0.3";for(var e=0,t=["select",'input[type="checkbox"]','input[type="radio"]','input[type="file"]'];e<t.length;e++){var i=t[e];u(document).on("input.inputevent",i,{selector:i},s.behavesOk).on("change.inputevent",i,{selector:i},s.misbehaves)}}},uninstall:function(){delete n.inputEventPatched,u(document).off(".inputevent")}})}).install(),_}),function(e,t){"object"==typeof exports&&"undefined"!=typeof module?module.exports=t():"function"==typeof define&&define.amd?define(t):e.AOS=t()}(this,function(){"use strict";function y(){return s.Date.now()}var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof self?self:{},w="Expected a function",n=NaN,o="[object Symbol]",r=/^\s+|\s+$/g,a=/^[-+]0x[0-9a-f]+$/i,l=/^0b[01]+$/i,d=/^0o[0-7]+$/i,c=parseInt,t="object"==typeof e&&e&&e.Object===Object&&e,i="object"==typeof self&&self&&self.Object===Object&&self,s=t||i||Function("return this")(),u=Object.prototype.toString,b=Math.max,k=Math.min;function p(s,n,e){var o,r,i,a,l,d,c=0,u=!1,p=!1,t=!0;if("function"!=typeof s)throw new TypeError(w);function h(e){var t=o,i=r;return o=r=void 0,c=e,a=s.apply(i,t)}function f(e){var t=e-d;return void 0===d||n<=t||t<0||p&&i<=e-c}function v(){var e,t=y();if(f(t))return m(t);l=setTimeout(v,(e=n-(t-d),p?k(e,i-(t-c)):e))}function m(e){return l=void 0,t&&o?h(e):(o=r=void 0,a)}function g(){var e,t=y(),i=f(t);if(o=arguments,r=this,d=t,i){if(void 0===l)return c=e=d,l=setTimeout(v,n),u?h(e):a;if(p)return l=setTimeout(v,n),h(d)}return void 0===l&&(l=setTimeout(v,n)),a}return n=S(n)||0,T(e)&&(u=!!e.leading,i=(p="maxWait"in e)?b(S(e.maxWait)||0,n):i,t="trailing"in e?!!e.trailing:t),g.cancel=function(){void 0!==l&&clearTimeout(l),o=d=r=l=void(c=0)},g.flush=function(){return void 0===l?a:m(y())},g}function T(e){var t=typeof e;return e&&("object"==t||"function"==t)}function S(e){if("number"==typeof e)return e;if("symbol"==typeof(t=e)||t&&"object"==typeof t&&u.call(t)==o)return n;var t,i;if(T(e)&&(e=T(i="function"==typeof e.valueOf?e.valueOf():e)?i+"":i),"string"!=typeof e)return 0===e?e:+e;e=e.replace(r,"");var s=l.test(e);return s||d.test(e)?c(e.slice(2),s?2:8):a.test(e)?n:+e}function C(){return x.Date.now()}var h=/^\s+|\s+$/g,f=/^[-+]0x[0-9a-f]+$/i,v=/^0b[01]+$/i,m=/^0o[0-7]+$/i,g=parseInt,$="object"==typeof e&&e&&e.Object===Object&&e,_="object"==typeof self&&self&&self.Object===Object&&self,x=$||_||Function("return this")(),A=Object.prototype.toString,O=Math.max,E=Math.min;function F(e){var t=typeof e;return e&&("object"==t||"function"==t)}function P(e){if("number"==typeof e)return e;if("symbol"==typeof(t=e)||t&&"object"==typeof t&&"[object Symbol]"==A.call(t))return NaN;var t,i;if(F(e)&&(e=F(i="function"==typeof e.valueOf?e.valueOf():e)?i+"":i),"string"!=typeof e)return 0===e?e:+e;e=e.replace(h,"");var s=v.test(e);return s||m.test(e)?g(e.slice(2),s?2:8):f.test(e)?NaN:+e}function M(s,n,e){var o,r,i,a,l,d,c=0,u=!1,p=!1,t=!0;if("function"!=typeof s)throw new TypeError("Expected a function");function h(e){var t=o,i=r;return o=r=void 0,c=e,a=s.apply(i,t)}function f(e){var t=e-d;return void 0===d||n<=t||t<0||p&&i<=e-c}function v(){var e,t=C();if(f(t))return m(t);l=setTimeout(v,(e=n-(t-d),p?E(e,i-(t-c)):e))}function m(e){return l=void 0,t&&o?h(e):(o=r=void 0,a)}function g(){var e,t=C(),i=f(t);if(o=arguments,r=this,d=t,i){if(void 0===l)return c=e=d,l=setTimeout(v,n),u?h(e):a;if(p)return l=setTimeout(v,n),h(d)}return void 0===l&&(l=setTimeout(v,n)),a}return n=P(n)||0,F(e)&&(u=!!e.leading,i=(p="maxWait"in e)?O(P(e.maxWait)||0,n):i,t="trailing"in e?!!e.trailing:t),g.cancel=function(){void 0!==l&&clearTimeout(l),o=d=r=l=void(c=0)},g.flush=function(){return void 0===l?a:m(C())},g}var z=function(){};function j(e){e&&e.forEach(function(e){var t=Array.prototype.slice.call(e.addedNodes),i=Array.prototype.slice.call(e.removedNodes);if(function e(t){for(var i=void 0,s=void 0,i=0;i<t.length;i+=1){if((s=t[i]).dataset&&s.dataset.aos)return 1;if(s.children&&e(s.children))return 1}}(t.concat(i)))return z()})}function D(){return window.MutationObserver||window.WebKitMutationObserver||window.MozMutationObserver}var H=function(){return!!D()},I=function(e,t){var i=window.document,s=new(D())(j);z=t,s.observe(i.documentElement,{childList:!0,subtree:!0,removedNodes:!0})},q=function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")},N=function(e,t,i){return t&&B(e.prototype,t),i&&B(e,i),e},L=Object.assign||function(e){for(var t=1;t<arguments.length;t++){var i=arguments[t];for(var s in i)Object.prototype.hasOwnProperty.call(i,s)&&(e[s]=i[s])}return e},V=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino/i,R=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i,W=/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i,U=/1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i;function B(e,t){for(var i=0;i<t.length;i++){var s=t[i];s.enumerable=s.enumerable||!1,s.configurable=!0,"value"in s&&(s.writable=!0),Object.defineProperty(e,s.key,s)}}function Y(){return navigator.userAgent||navigator.vendor||window.opera||""}function Z(e,t){var i=void 0;return ie.ie11()?(i=document.createEvent("CustomEvent")).initCustomEvent(e,!0,!0,{detail:t}):i=new CustomEvent(e,{detail:t}),document.dispatchEvent(i)}function X(e){return e.forEach(function(e,t){return i=e,s=window.pageYOffset,r=i.options,a=i.position,l=i.node,i.data,d=function(){var t,e;i.animated&&(t=l,(e=r.animatedClassNames)&&e.forEach(function(e){return t.classList.remove(e)}),Z("aos:out",l),i.options.id&&Z("aos:in:"+i.options.id,l),i.animated=!1)},void(r.mirror&&s>=a.out&&!r.once?d():s>=a.in?i.animated||(n=l,(o=r.animatedClassNames)&&o.forEach(function(e){return n.classList.add(e)}),Z("aos:in",l),i.options.id&&Z("aos:in:"+i.options.id,l),i.animated=!0):i.animated&&!r.once&&d());var i,s,n,o,r,a,l,d})}function G(e){for(var t=0,i=0;e&&!isNaN(e.offsetLeft)&&!isNaN(e.offsetTop);)t+=e.offsetLeft-("BODY"!=e.tagName?e.scrollLeft:0),i+=e.offsetTop-("BODY"!=e.tagName?e.scrollTop:0),e=e.offsetParent;return{top:i,left:t}}function Q(e,t,i){var s=e.getAttribute("data-aos-"+t);if(void 0!==s){if("true"===s)return!0;if("false"===s)return!1}return s||i}function J(){var e=document.querySelectorAll("[data-aos]");return Array.prototype.map.call(e,function(e){return{node:e}})}function K(){return document.all&&!window.atob}function ee(){var e,a;0<arguments.length&&void 0!==arguments[0]&&arguments[0]&&(ne=!0),ne&&(a=oe,(e=se).forEach(function(e,t){var i=Q(e.node,"mirror",a.mirror),s=Q(e.node,"once",a.once),n=Q(e.node,"id"),o=a.useClassNames&&e.node.getAttribute("data-aos"),r=[a.animatedClassName].concat(o?o.split(" "):[]).filter(function(e){return"string"==typeof e});a.initClassName&&e.node.classList.add(a.initClassName),e.position={in:function(e,t,i){var s=window.innerHeight,n=Q(e,"anchor"),o=Q(e,"anchor-placement"),r=Number(Q(e,"offset",o?0:t)),a=o||i,l=e;n&&document.querySelectorAll(n)&&(l=document.querySelectorAll(n)[0]);var d=G(l).top-s;switch(a){case"top-bottom":break;case"center-bottom":d+=l.offsetHeight/2;break;case"bottom-bottom":d+=l.offsetHeight;break;case"top-center":d+=s/2;break;case"center-center":d+=s/2+l.offsetHeight/2;break;case"bottom-center":d+=s/2+l.offsetHeight;break;case"top-top":d+=s;break;case"bottom-top":d+=s+l.offsetHeight;break;case"center-top":d+=s+l.offsetHeight/2}return d+r}(e.node,a.offset,a.anchorPlacement),out:i&&function(e,t){window.innerHeight;var i=Q(e,"anchor"),s=Q(e,"offset",t),n=e;return i&&document.querySelectorAll(i)&&(n=document.querySelectorAll(i)[0]),G(n).top+n.offsetHeight-s}(e.node,a.offset)},e.options={once:s,mirror:i,animatedClassNames:r,id:n}}),X(se=e),window.addEventListener("scroll",function(e,t,i){var s=!0,n=!0;if("function"!=typeof e)throw new TypeError(w);return T(i)&&(s="leading"in i?!!i.leading:s,n="trailing"in i?!!i.trailing:n),p(e,t,{leading:s,maxWait:t,trailing:n})}(function(){X(se,oe.once)},oe.throttleDelay)))}function te(){if(se=J(),ae(oe.disable)||K())return re();ee()}var ie=(N(le,[{key:"phone",value:function(){var e=Y();return!(!V.test(e)&&!R.test(e.substr(0,4)))}},{key:"mobile",value:function(){var e=Y();return!(!W.test(e)&&!U.test(e.substr(0,4)))}},{key:"tablet",value:function(){return this.mobile()&&!this.phone()}},{key:"ie11",value:function(){return"-ms-scroll-limit"in document.documentElement.style&&"-ms-ime-align"in document.documentElement.style}}]),new le),se=[],ne=!1,oe={offset:120,delay:0,easing:"ease",duration:400,disable:!1,once:!1,mirror:!1,anchorPlacement:"top-bottom",startEvent:"DOMContentLoaded",animatedClassName:"aos-animate",initClassName:"aos-init",useClassNames:!1,disableMutationObserver:!1,throttleDelay:99,debounceDelay:50},re=function(){se.forEach(function(e,t){e.node.removeAttribute("data-aos"),e.node.removeAttribute("data-aos-easing"),e.node.removeAttribute("data-aos-duration"),e.node.removeAttribute("data-aos-delay"),oe.initClassName&&e.node.classList.remove(oe.initClassName),oe.animatedClassName&&e.node.classList.remove(oe.animatedClassName)})},ae=function(e){return!0===e||"mobile"===e&&ie.mobile()||"phone"===e&&ie.phone()||"tablet"===e&&ie.tablet()||"function"==typeof e&&!0===e()};function le(){q(this,le)}return{init:function(e){return oe=L(oe,e),se=J(),oe.disableMutationObserver||H()||(console.info('\n      aos: MutationObserver is not supported on this browser,\n      code mutations observing has been disabled.\n      You may have to call "refreshHard()" by yourself.\n    '),oe.disableMutationObserver=!0),oe.disableMutationObserver||I("[data-aos]",te),ae(oe.disable)||K()?re():(document.querySelector("body").setAttribute("data-aos-easing",oe.easing),document.querySelector("body").setAttribute("data-aos-duration",oe.duration),document.querySelector("body").setAttribute("data-aos-delay",oe.delay),-1===["DOMContentLoaded","load"].indexOf(oe.startEvent)?document.addEventListener(oe.startEvent,function(){ee(!0)}):window.addEventListener("load",function(){ee(!0)}),"DOMContentLoaded"===oe.startEvent&&-1<["complete","interactive"].indexOf(document.readyState)&&ee(!0),window.addEventListener("resize",M(ee,oe.debounceDelay,!0)),window.addEventListener("orientationchange",M(ee,oe.debounceDelay,!0)),se)},refresh:ee,refreshHard:te}});

// document.documentElement.className = document.documentElement.className.replace(/\bno-js\b/g, "") + "js";
// if (window.location.hash) { setTimeout(function () { window.scrollTo(0, 0); }, 2); }

jQuery(document).ready(function ($) {



    /*-----------------------------------------------------------------------------GLOBAL ON LOAD----*/

    //Load images, and images after doc ready
    var lazyLoadImages = (function () {
        var $lazyImages = $('img[data-src], iframe[data-src], script[data-src], [data-background]');
        if (!$lazyImages.length) { return; }

        function init() {
            $lazyImages.each(function () {
                var $this = $(this),
                    delay = 0,
                    dataSrc;
                if (dataSrc = $this.data('background')) {
                    if ($this.data('src-delay')) {
                        delay = $this.data('src-delay');
                    }
                    setTimeout(function () {
                        $this.css('background-image', 'url(' + dataSrc + ')');
                        $this.attr('data-background', null);
                    }, delay);
                } else if (dataSrc = $this.data('src')) {
                    if ($this.data('src-delay')) {
                        delay = $this.data('src-delay');
                    }
                    setTimeout(function () {
                        $this.attr('src', dataSrc);
                        $this.attr('data-src', null);
                    }, delay);
                }
            });
        }
        init();
        return { init: init }
    }());
    
    function updateHeights(){
        $('.template-index .hero-slide').css({ "min-height": $(window).outerHeight() - $('header').outerHeight() });
//        $('body').css({ 'padding-top': $('header').outerHeight() });
        
        $('.mega-menu').css({ top: $('header').outerHeight() });
        $('.scroll-progress').css({ top: $('header').outerHeight() });
        
        $('.bc-sf-filter-left-col').css({ 'top': $('header').outerHeight() + 32 });
        $('.product-intro__form .content-wrapper').css({ 'top': $('header').outerHeight() + 32 });
        $('.toc ul').css({ 'top': $('header').outerHeight() + 32 });
        $('.feat-collections__nav ol').css({ 'top': $('header').outerHeight() + 32 });
        
    }

    updateHeights();

    $(window).resize(function(){
        updateHeights();
    });
    

    //Global function to toggle simple accordions
    var Accordions = (function () {
        var $accordions = $('.accordion');
        if (!$accordions.length) { return; }

        $accordions.each(function () {
            $this = $(this).find('.accordion__trigger');
            if ($this.hasClass('active')) {
                $this.next().slideToggle(250);
            }
        });
        
        $(document).on('click', '.accordion__trigger', function () {
            var $this = $(this);
            $this.toggleClass('active');
            $this.next().slideToggle(250);
            $this.parent().siblings().find('.accordion__trigger').removeClass('active').next().slideUp(250);
        });
    }());

    //
    var InputMasks = (function () {
        var $masks = $('[data-mask]');
        if (!$masks.length) { return; }

        $('[data-mask]').keyup(function (e) {
            switch (this.dataset.mask) {
                case 'phone':
                    var x = this.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
                    this.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
                    break;
                case 'ssn': {
                    var x = this.value.replace(/\D/g, '').match(/^(\d{0,3})(\d{0,2})(\d{0,4})/);
                    this.value = !x[2] ? x[1] : x[1] + '-' + x[2] + '-' + x[3];
                }
            }
        });
    }());

    //Plugin used for form validation
    var parselyOptions = {
        classHandler: function (parsleyField) {
            var $element = parsleyField.$element;
            if ($element.parent().hasClass('select-menu')) {
                return $element.parent();
            }
            return $element;
        },
        errorsContainer: function (parsleyField) {
            var $element = parsleyField.$element;
            var $fieldContainer = $element.closest('.form-field');
            if ($fieldContainer) {
                return $fieldContainer;
            }
        }
    };

    //Global function to set form state classes
    var formStates = (function () {
        $formInputs = $('main form :input');
        if (!$formInputs.length) { return; }

        $formSelectMenus = $('.select-menu select, .ginput_container_select select');

        function isGFormInput($el) {
            return $el.hasClass('ginput_container') ? $el.parent() : $el;
        }

        function setFilled($input) {
            var $parent = isGFormInput($input.parent());

            $parent.addClass('filled');
        }

        function removeFilled($input) {
            var $parent = isGFormInput($input.parent());

            $parent.removeClass('filled');
        }

        function setFocused() {
            var $parent = isGFormInput($(this).parent());

            $parent.addClass('focused');
        }

        function removeFocused() {
            var $parent = isGFormInput($(this).parent());

            $parent.removeClass('focused');
        }

        function checkInput(e) {
            if (this.type == 'button' ||
                this.type == 'range' ||
                this.type == 'submit' ||
                this.type == 'reset') { return; }

            var $this = $(this);
            var $parent = $this.parent();
            var is_selectMenu = $parent.hasClass('select-menu') || $parent.hasClass('ginput_container_select');

            var $input = is_selectMenu ? $parent : $this;

            switch (this.type) {
                case 'select-one':
                case 'select-multiple':
                    if (this.value !== '') {
                        setFilled($input);
                    } else {
                        removeFilled($input);
                    }
                    break;
                default:
                    if (this.value) {
                        setFilled($input);
                    } else {
                        removeFilled($input);
                    }
                    break;
            }
        }

        $formInputs.each(checkInput);
        $formInputs.on('change', checkInput);
        $formInputs.on('focus', setFocused);
        $formInputs.on('blur', removeFocused);
        $formSelectMenus.on('focus', setFocused);
        $formSelectMenus.on('blur', removeFocused);

    }());
    
    var QtyInput = (function () {
        var $qtyInputs = $('.qty-input');

        if (!$qtyInputs.length) { return; }

        var $inputs = $qtyInputs.find('.product-qty');
        var $countBtn = $qtyInputs.find('.qty-count');

        $inputs.change(function () {
            var $this = $(this);
            var $minusBtn = $this.siblings('.qty-count--minus');
            var qty = parseInt($this.val());

            if (isNaN(qty) || qty <= 1) {
                $this.val("1");
                $minusBtn.attr('disabled', true);
            } else {
                $minusBtn.attr('disabled', false);
                $this.val(qty);
            }

        });

        $countBtn.click(function (e) {
            e.preventDefault();
            var operator = this.dataset.action;
            var $this = $(this);
            var $input = $this.siblings('.product-qty');
            var qty = parseInt($input.val());

            if (operator == 'add') {
                qty += 1;
                if (qty == 2) {
                    $this.siblings('.qty-count--minus').attr('disabled', false);
                }
            } else {
                qty = qty <= 1 ? 1 : qty -= 1;
                if (qty == 1) {
                    $this.attr('disabled', true);
                }
            }

            $input.val(qty);
        });
    }());

    //Global function top open / close lightboxes
    var PDMLightbox = (function () {
        //Lightbox reset - This lightbox is empty and present on all pages
        var $lightbox = $('.pdm-lightbox--reset');

        //it's content can be filled from various sources
        //after close, the content is wiped
        var $lightbox_content = $('.pdm-lightbox--reset .pdm-lightbox__content');

        $('body').on('click', '[data-lightbox-iframe],[data-lightbox-content],[data-lightbox-target],.lightbox-trigger', function (e) {

            e.preventDefault();

            var iframe = $(this).data('lightbox-iframe');

            if (iframe) {
                $lightbox_content.html('<div class="iframe-wrap">' + iframe + '</div>');
            } else {
                if ($(this).data('lightbox-content')) {
                    var content = $(this).data('lightbox-content');
                } else if ($(this).data('lightbox-target')) {
                    var target = $(this).data('lightbox-target');
                    var content = $('#' + target).html();
                } else {
                    var content = $(this).siblings('.lightbox-content').html();
                }
                $lightbox_content.html(content);
            }

            var classes = $(this).data('lightbox-classes');
            $lightbox.addClass('active').addClass(classes);

        });

        function closeLightbox($lightbox) {
            $lightbox.removeClass('active');
            $('body').removeClass('noScroll');
            //wait before removing classes till lightbox closses
            if ($lightbox.hasClass('pdm-lightbox--reset')) {
                setTimeout(function () {
                    $lightbox.find('.pdm-lightbox__content').empty();
                    $lightbox.attr('class', 'pdm-lightbox pdm-lightbox--reset');
                }, 750);
            }
        }

        $('.pdm-lightbox').on('click', function (e) {
            var $lightbox = $(this);
            if (e.target == this) {
                closeLightbox($lightbox);
            }
        });

        $('.pdm-lightbox__close').click(function (e) {
            e.stopPropagation();
            $lightbox = $(this).closest('.pdm-lightbox');
            closeLightbox($lightbox);
        });
        return {
            close: closeLightbox
        };
    }());
    
   //Global function to smooth scroll inside pages
    var SmoothScroll = (function () {
        var $anchorLinks = $('a[href^="#"]').not('[href="#"]');

        function getHeaderGroupHeight() {
            var headerGroupHeight = parseFloat(
                window.getComputedStyle(document.documentElement).getPropertyValue('--header-group-height')
            );

            if (!isNaN(headerGroupHeight)) { return headerGroupHeight; }

            var header = document.querySelector('header.header_new');
            var announcement = document.querySelector('.announcement-bar-section.header__banner');

            return (header ? header.offsetHeight : 0) + (announcement ? announcement.offsetHeight : 0);
        }

        function goTo(target) {
            if (target === "" || !$(target).length) { return; }
            var scrollPos = typeof target === 'number' ? target : $(target).offset().top;

            scrollPos -= getHeaderGroupHeight();

            $('html, body').stop().animate({
                'scrollTop': scrollPos
            }, 1200, 'swing', function () {
                if (typeof target === 'string') {

                    if (window.location.hash) {
                        window.location.hash = target;
                    }
                }
            });
        }

        if (window.location.hash) {
            setTimeout(function () {
                goTo(window.location.hash);
            }, 500);
        }

        if ($anchorLinks.length) {
            $anchorLinks.on('click', function (e) {
                if (!$("#" + this.hash.replace('#', '')).length) { return; }
                e.preventDefault();
                goTo(this.hash);
            });
        }

        return { to: goTo }
    }());
    
    //Global function to grab parameters from url
    var urlParams = (function (strParam) {
        var objParams = {};

        function init() {
            objParams = {};
            var arrURLParams = window.location.search.replace('?', '').split('&');
            arrURLParams.map(function (val) {
                var arrPair = val.split('=');
                objParams[arrPair[0]] = decodeURIComponent(arrPair[1]);
            });
        }
        init();
        return {
            get: function (strParam) { return objParams[strParam]; },
            pull: init
        }
    }());
    
    var header = (function(){
        
        function adjustOnLoad(){
            if( !$('header').hasClass('sticky') ){
                $('header').addClass('sticky');
                $('body').css({ 'padding-top': $('header').outerHeight() });
            }
        }
        
        //adjustOnLoad();
        
        
        $dropdowns = $('li.haslinks');
        $dropdownsLinks = $('li.haslinks > a');
        
        $dropdowns.each(function(){
            $(this).find('ul').prepend('<li><button class="reset back-menu">Back</button></li>');
        });
                
        $dropdowns.on('click', '.back-menu', function(e){
            
            $(this).parent().parent().removeClass('active');
            $('header ul.opaque').removeClass('opaque');
            
        });
                
        $dropdownsLinks.click(function(e){
            
            e.preventDefault();
            
            var $this = $(this)
            
            if( $(window).width() < 960 ){
                
                $this.parent().parent().addClass('opaque');
                $this.next('ul').addClass('active');
                
            }else{
                
                var megaMenu = $this.data('megamenu');
                
                if( $this.parent().hasClass('active-megamenu') ){
                    
                    closeMegaMenus();
                    
                }else{
                    
                    $('li.haslinks').removeClass('active-megamenu');
                    $('li').removeClass('active');
                    $this.parent().addClass('active-megamenu')
                    
                    $('body').addClass('no-scroll body--overlay');
                    $('header').addClass('active');

                    $('.mega-menu').hide();
                    $('#mega-menu-'+megaMenu).fadeIn();
                    
                }
                
            }
            
        });
        
        $('body').on('click', function (e) {
            if (e.target == this) {
                closeMegaMenus();
            }
        });
        

        $links = $('.mega-menu a');

        $links.mouseenter(function () {

            var image = $(this).data('image');

            $(this).parent().parent().parent().find('.featured-image img').attr('src', image);

        });        
        
    }());
    
    function closeMegaMenus(){
    
        $('li.haslinks').removeClass('active-megamenu');
        $('body').removeClass('no-scroll body--overlay');
        $('header').removeClass('active');
        $('.mega-menu').fadeOut();
        
    }
  
    /*var header = (function(){

      function adjustOnLoad(){
          if( !$('header').hasClass('sticky') ){
              $('header').addClass('sticky');
              $('body').css({ 'padding-top': $('header').outerHeight() });
          }
      }
    
      //adjustOnLoad();
        
        // Mobile menu click behavior is handled above
    
        $dropdowns = $('li.haslinks');
        $dropdownsLinks = $('li.haslinks > a');
        
        $dropdowns.each(function(){
            $(this).find('ul').prepend('<li><button class="reset back-menu">Back</button></li>');
        });
    
        $dropdowns.on('click', '.back-menu', function(e){
            $(this).parent().parent().removeClass('active');
            $('header ul.opaque').removeClass('opaque');
        });
        
        $dropdownsLinks.mouseenter(function(e){
            e.preventDefault();
    
            var $this = $(this);
            
            if( $(window).width() < 960 ){
                $this.parent().parent().addClass('opaque');
                $this.next('ul').addClass('active');
            } else {
                var megaMenu = $this.data('megamenu');
                
                if( $this.parent().hasClass('active-megamenu') ){
                    closeMegaMenus();
                } else {
                    $('li.haslinks').removeClass('active-megamenu');
                    $('li').removeClass('active');
                    $this.parent().addClass('active-megamenu');
                    
                    $('body').addClass('no-scroll body--overlay');
                    $('header').addClass('active');
    
                    $('.mega-menu').hide();
                    $('#mega-menu-' + megaMenu).fadeIn();
                }
            }
        });
    
        $('body').on('click', function (e) {
            if (e.target == this) {
                closeMegaMenus();
            }
        });
    
        $links = $('.mega-menu a');
    
        $links.mouseenter(function () {
            var image = $(this).data('image');
            $(this).parent().parent().parent().find('.featured-image img').attr('src', image);
        });
        
    }());*/

  
     var homepageCollection = (function () {

        $('.feat-links--genre .feat-links__grid').slick({
            mobileFirst: true,
            slidesToShow: 1,
    		slidesToScroll: 1,
            infinite: true,
            autoplay: false,
            arrows: false,
            dots: true,
            autoplaySpeed: 5000,
            responsive: [{
                    breakpoint: 768,
                    settings: 'unslick'

                }
            ]
        });

    }());

     var headerAnnouncementSlider = (function () {

        $('.header__announcement-slider').slick({
            slidesToShow: 1,
    		slidesToScroll: 1,
            infinite: true,
            autoplay: true,
            arrows: false,
            dots: false,
            autoplaySpeed: 3000
        });

    }());
     


     var revGoSlider = (function () {

        $('.landing-page-image-gallery-row').slick({

            slidesToShow: 1,
            mobileFirst: true,
            infinite: true,
            autoplay: true,
            prevArrow: $('.landing-page-image-gallery .slider-nav .slick-prev'),
            nextArrow: $('.landing-page-image-gallery .slider-nav .slick-next'),
            autoplaySpeed: 5000,
            responsive: [{
                    breakpoint: 960,
                    settings: {
                        slidesToShow: 5
                    }
                }
            ]
        });

    }());

     var revGoReviews = (function () {

     	$sliders = $('.revgo-review-slider');
  		if (!$sliders.length) { return };
   			$sliders.each(function () {
   			var $slider = $(this);
            $slider.slick({
	    		slidesToShow: 1,
	            infinite: true,
	            prevArrow: $(this).parent().find(".slider-nav .slick-prev"),
            	nextArrow: $(this).parent().find(".slider-nav .slick-next")
	
            });

   	 	});

    }());     
    
    var hero = (function () {

        $('.hero-slider__slides').slick({

            slidesToShow: 1,
            mobileFirst: true,
            prevArrow: $('.hero-slider .slick-prev'),
            nextArrow: $('.hero-slider .slick-next'),
            infinite: false,
            autoplay: true,
            autoplaySpeed: 5000
        });

        $('.hero-slider .slick-dot').click(function (e) {
            e.preventDefault();
            $('.hero-slider .slick-dot').removeClass('current');
            var slideno = $(this).data('target');
            $(this).addClass('current');
            $('.hero-slider__slides').slick('slickGoTo', slideno - 1);
        });

        $('.hero-slider__slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
            var current = nextSlide + 1;
            $('.hero-slider .slick-dot').removeClass('current');
            $('.hero-slider .slick-dot[data-target="' + current + '"]').addClass('current');
        });

    }());
    
    var scrollDownSection = (function () {

        $('.scroll-down-section').click(function () {

            $parent = $(this).closest('section');
            
//            console.log( $parent.scrollTop() );

            $('html, body').stop().animate({
                'scrollTop': $parent.offset().top + $parent.outerHeight() - $('header').outerHeight()
            }, 1200);

        });

    }());

    var featCollection = (function () {

        var $sliders = $('.featured-collection__grid');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
                    slidesToShow: 1,
                    infinite: false,
                    //                    autoplay:true,
                    dots: true,
                    mobileFirst: true,
                    responsive: [{
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 4,
                                slidesToScroll: 4,
                            }
                        }
                    ]
                });

            });

        }

    }());

    var clubHero = (function () {
    	 $sliders = $('.club-slider__slides');
    	  if (!$sliders.length) { return };
	   		$sliders.each(function () {
	   			var $slider = $(this);
	            var $slider_card = $(this).find('.club-slide');
	            if($slider_card.length > 1) {
	        $('.club-slider__slides').slick({
	            slidesToShow: 1,
	            mobileFirst: true,
	            prevArrow: $('.hero-slider .slick-prev'),
	            nextArrow: $('.hero-slider .slick-next'),
	            infinite: false,
	            autoplay: true,
	            autoplaySpeed: 5000
	        });


	        $('.club-slider .slick-dot').click(function (e) {
	            e.preventDefault();
	            $('.club-slider .slick-dot').removeClass('current');
	            var slideno = $(this).data('target');
	            $(this).addClass('current');
	            $('.club-slider__slides').slick('slickGoTo', slideno - 1);
	        });

	        $('.club-slider__slides').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
	            var current = nextSlide + 1;
	            $('.club-slider .slick-dot').removeClass('current');
	            $('.club-slider .slick-dot[data-target="' + current + '"]').addClass('current');
	        });
    	} else {
    		  $slider.closest(".club-slider").find('.slider-nav').addClass("slider-nav--hide");
    	}

        });

    }());

    var recProducts = (function () {

        var $sliders = $('.recommended-products__grid');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
                    slidesToShow: 1,
                    infinite: false,
                    //                    autoplay:true,
                    dots: true,
                    mobileFirst: true,
                    responsive: [{
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 3,
                                slidesToScroll: 3,
                            }
                        }
                    ]
                });

            });

        }

    }());
    
    var boxLinks = (function () {

        var $sliders = $('.box-links__grid');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
                    slidesToShow: 1,
                    infinite: false,
                    //                    autoplay:true,
                    dots: true,
                    mobileFirst: true,
                    responsive: [
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 2,
                                slidesToScroll: 2,
                            }
                        }
                    ]
                });

            });

        }

    }());

    var testimonials = (function () {

        var $sliders = $('.testimonials__slider');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
                    slidesToShow: 1,
                    infinite: false,
                    //                    autoplay:true,
                    //                    dots:true,
                    prevArrow: $('.testimonials__quotes .slick-prev'),
                    nextArrow: $('.testimonials__quotes .slick-next'),
                    asNavFor: $('.testimonials__images'),
                    mobileFirst: true,
                });

            });

            $('.testimonials__images').each(function () {

                $(this).slick({
                    slidesToShow: 1,
                    infinite: false,
                    //                    autoplay:true,
                    dots: false,
                    arrows: false,
                    asNavFor: $('.testimonials__slider'),
                    mobileFirst: true,
                    fade: true,
                });

            });

            $('.testimonials__quotes .slick-dot').click(function (e) {
                e.preventDefault();
                $('.testimonials__quotes .slick-dot').removeClass('current');
                var slideno = $(this).data('target');
                $(this).addClass('current');
                $('.testimonials__slider').slick('slickGoTo', slideno - 1);
            });

            $('.testimonials__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var current = nextSlide + 1;
                $('.testimonials__quotes .slick-dot').removeClass('current');
                $('.testimonials__quotes .slick-dot[data-target="' + current + '"]').addClass('current');
            });

        }

    }());

       var subscriptionTestimonials = (function () {

        var $sliders = $('.sub-testimonials-slider');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
                    slidesToShow: 1,
                    infinite: false,
                    prevArrow: $('.subscription-testimonials .slick-prev'),
                    nextArrow: $('.subscription-testimonials .slick-next'),
                    mobileFirst: true,
                });

            });

        }

    }());


   var subscriptionGenres = (function () {

        var $sliders = $('.subscription-sample-slider');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
                    slidesToShow: 3,
                    infinite: false,
                    prevArrow: $('.subscription-sample .slick-prev'),
                    nextArrow: $('.subscription-sample .slick-next'),
                    responsive: [
					    {
					      breakpoint: 992,
					      settings: {
					        slidesToShow: 1,
					      }
		    			}
    				]

                });

            });

        }

    }());       

    var sliderContent = (function () {

        var $sliders = $('.slider-content__slider');

        if ($sliders.length) {

            $sliders.each(function () {
                
                $slider = $(this);

                $slider.slick({
                    slidesToShow: 1,
                    infinite: false,
                    //                    autoplay:true,
                    //                    dots:true,
                    prevArrow: $(this).parent().find('.slick-prev'),
                    nextArrow: $(this).parent().find('.slick-next'),
                    mobileFirst: true,
                });

                
            });

            $('.slider-content .slick-dot').click(function (e) {
                e.preventDefault();
                $(this).closest('.slider-content').find('.slick-dot').removeClass('current');
                var slideno = $(this).data('target');
                $(this).addClass('current');
                $(this).closest('.slider-content').find('.slider-content__slider').slick('slickGoTo', slideno - 1);
            });

            $('.slider-content__slider').on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                var current = nextSlide + 1;
//                console.log(current);
                $(this).parent().find('.slick-dot').removeClass('current');
                $(this).parent().find('.slick-dot[data-target="' + current + '"]').addClass('current');
            });

        }

    }());

    var awards = (function () {

        var $sliders = $('.awards__grid');

        if ($sliders.length) {

            $sliders.each(function () {

                $(this).slick({
//                    dots: false,
                    mobileFirst: true,
//                    touchThreshold:100,
//                    infinite: true,
                    speed: 4000,
                    autoplay: true,
                    autoplaySpeed: 0,
                    cssEase: 'linear',
                    slidesToShow: 1,
                    slidesToScroll: 1,
//                    variableWidth: true,
//                    draggable:true,
                    responsive: [{
                            breakpoint: 500,
                            settings: {
                                slidesToShow: 2,
                            }
                        },
                        {
                            breakpoint: 960,
                            settings: {
                                slidesToShow: 3,
                            }
                        },
                        {
                            breakpoint: 1200,
                            settings: {
                                slidesToShow: 5,
                            }
                        }
                    ]
                });

            });

        }

    }());

    var LoadMorePosts = (function () {
        var $section = $('.load-more');
        if (!$section.length) { return; }

        var $posts = $('.blog-card');
        var $loadBtn = $('.load-more__btn');
        var postsToLoad = 12;

        $posts.hide();
        $posts.slice(0, postsToLoad).show();

        $loadBtn.click(function () {
            var shown = $('.blog-card:visible').length;

            $posts.slice(shown - 1, shown + postsToLoad).show();

            if ($posts.length == $('.blog-card:visible').length) {
                $section.remove();
            }
        });

    }());
    
    var productImageSlider = (function(){
        
        
        $('.product-intro__slider').slick({
			slidesToShow:1,
			infinite: true,
			autoplay: false,
			arrows: false,
			dots: false,
			asNavFor: '.product-intro__thumbs-slider',
		});

		$('.product-intro__thumbs-slider').slick({
			slidesToShow:3,
			infinite: true,
			autoplay: false,
			arrows: true,
			dots: false,
			centerMode: true,
			centerPadding: '1px',
			asNavFor: '.product-intro__slider',
			mobileFirst: true,
			focusOnSelect: true,
			responsive:[
                {
                    breakpoint: 400,
                    settings: {
                        slidesToShow: 4,
                    }
                }
			]
		});
        
    }());

    var addToCartGoogle = (function(){
    	$('.product-details').on('change', '.product-options-check .option-group select', function(){
            var optionName = $(this).find("option:selected").text();
    		var product = $(this).closest(".content-wrapper").find(".product-options-check");
    		$(product).attr("data-product-variant",optionName);

    		
    	});
        $('.product-details').on('click', '#addtocart', function(){

		var productQty = $(".product-qty").val();

    	var product = $(this).closest(".content-wrapper").find(".product-options-check");

		$(product).attr("data-product-quantity",productQty);

    	var productID = $(product).data("productid");
    	var productPrice = $(product).data("product-price");
    	var productVariant = $(product).data("product-variant");
    	var productTitle = $(product).data("product-name");
    	var productQuantity = $(product).data("product-quantity");


    	window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
		  event: 'add_to_cart',
		  ecommerce: {
		    items: [{
		      item_name: productTitle,
		      item_id: productID,
		      price: productPrice,	
		      item_variant: productVariant,
		      quantity: productQuantity
		    }]
		  }
		});

        });
    }());


   	var removeCartGoogle = (function(){
     	$('.cart-item__remove').on('click', '.svg-icon--close', function(){
    	var product = $(this).closest("tr").find(".tc-product");
    	var productID = $(product).data("product-id");
    	var productPrice = $(product).data("product-price");
    	var productVariant = $(product).data("variant-title");
    	var productTitle = $(product).data("product-name");
    	var productQuantity = $(product).data("product-quantity");

     	window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({
		  event: 'remove_from_cart',
		  ecommerce: {
		    items: [{
		      item_name: productTitle,
		      item_id: productID,
		      price: productPrice,	
		      item_variant: productVariant,
		      quantity: productQuantity
		    }]
		  }
		});
        });
    }());

    var beginCheckout = (function(){
     	$('.the-cart').on('click', '.checkout', function(){
     		var products = [];

			$( ".begin-checkout" ).each(function( index ) {
			
			  	var productID = $(this).data("product-id");
    			var productPrice = $(this).data("product-price");
    			var productVariant = $(this).data("variant-title");
    			var productTitle = $(this).data("product-name");
    			var productQuantity = $(this).data("product-quantity");


				products.push({
	                'item_name': productTitle,
	                'item_id': productID,
	                'price': productPrice,
	                'item_variant': productVariant,
	                'quantity': productQuantity
	            });
			});
			window.dataLayer = window.dataLayer || [];
				window.dataLayer.push({
				  event: 'begin_checkout',
				  ecommerce: {
				    items: products
				  }
				});

		/*	$.each(products, function(index, array) { // This each iterates over the arrays.
			  $.each(array, function(subindex, value) { // This each iterates over the individual values.
			    console.log(subindex); // Logs the individual values.
			  });
			});*/
    
     	
        });
    }());
    
    var productPage = (function(){
        
        var $atcForm = $('.product-intro__form form');

        $atcForm.submit(function (e) {

            var $select = $(this).find('.product-option-select');
            var isValid = true;
            $select.each(function () {
                var $this = $(this);
                var $parent = $this.parent().parent();
                var $validation = $parent.find('.validation-error');
                if ($this.val() == null || $this.val() == '') {
                    $validation.removeClass('hide');
                    isValid = false;
                } else {
                    $validation.addClass('hide');
                }
            });

            if (!isValid) {
                e.preventDefault();
            }

        });
        
        var $bundleBtn = $('.product-upsells__atc');
        
        $bundleBtn.click(function(e){
            
            e.preventDefault();
            
            var currentProduct = $('.product-select').val();
            var upsells = $(this).data('upsells');
            
            if( currentProduct == null ){
                currentProduct = $('.product-select').data('first');
            }
            
//            console.log( currentProduct );
//            console.log( upsells );
            
            var url = '/cart/add?id[]='+currentProduct+upsells;
            
//            console.log( url );
            
            window.location.href = url;
            
        });
        
        
    }());
    
    var collections = (function(){
        
        $('.template-collection main').on('click', '.bc-sf-filter-block-content li', function(){
            
            var $collectionSection = $('.product-collection .container');
            
            $('html, body').animate({
                scrollTop: $collectionSection.offset().top - $('header').outerHeight()
            }, 1000);
            
        });
        
    }());
    
    var addressPage = (function(){
        
        $('button.add-address').click(function(){
            $('.add-address-lightbox').addClass('active');
        });
        
        $('.edit-address').click(function(){
            var target = $(this).data('target');
            $('#lightbox-'+target).addClass('active');
        });
        
    }());
    
    AOS.init();

    function KlaviyoSubscribe(listID,email,source) {
        $.ajax({
            type: "POST",
            url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
            data: {
            g: listID,
                email: email,
                //pass in additional fields
                $fields: "$source, $first_name, $last_name",
                $source: source,
            },
            contentType: "application/x-www-form-urlencoded",
            error: function (err) {
                // Handle Klaviyo connection error
            },
            success: function (data) {
                // Handle successful Klaviyo response
            }
        });
    }
    
    var footerMailchimp = (function(){
        $('footer form.klaviyo-form').submit(function(e){
            e.preventDefault();
            var $this = $(this)
            var email = $(this).find('input[type="email"]').val();
            var $errors = $('.mailchimp-errors-or-success');
            
            var listID = $this.hasClass('record-store') ? $this.data('recordStoreListId') : $this.data('listId');
            var source = $this.hasClass('record-store') ? $this.data('recordStoreSource') : $this.data('source');

            KlaviyoSubscribe(listID, email, source);
            
            $this.hide();
            $errors.empty();
            var successMessage = $this.data('successMessage');
            $errors.html($('<p>', { class: 'success', text: successMessage }));

        });
   }());
    
    var joinTheClub = (function(){
        $('.jtc__form form').submit(function(e){
            e.preventDefault();
            
            var $this = $(this)
            var email = $(this).find('input[type="email"]').val();
            var $errors = $('.mailchimp-errors-or-success');
            
            KlaviyoSubscribe('WtyGpu', email, 'Join The Club Form');

            $this.hide();
            $errors.empty();
            var error = "<p class='success'>Thank you for subscribing!</p>"
            $errors.html(error);

        });
   }());
    
    var productTabs = (function(){
        
        var $buttons = $('.product-tabs__nav button');
        
        if( $buttons.length ){
            
            $buttons.click(function(){
                
                var target = $(this).data('tab');
                
                $('.product-tabs__nav button.active').removeClass('active');
                $(this).addClass('active');
                
                $('.product-tabs .accordion__trigger.active + .accordion__content').fadeOut(function(){
                    $('.product-tabs .accordion[data-tab="'+target+'"]').find('.accordion__content').fadeIn();
                });
                $('.product-tabs .accordion__trigger.active').removeClass('active');
                
                $('.product-tabs .accordion[data-tab="'+target+'"]').find('.accordion__trigger').addClass('active');
                
            });
            
        }
        
    }());
    
    var productOptionsCheck = (function () {
       
        //on load go through the different option categories, go through the single values and make sure that atleast one of them is available, if it is not hide the option
        $('.product-options-check .option-group').each(function(){
            checkAvailableOptions( $(this) );    
        });

        //when a color swatch is clicked trigger the selection of the right value on its select field
        var $options = $('.product-options-check button:not(.disabled)');
        $options.click(function () {
            
            var $this = $(this);
            var selection = $this.val();
            var $group = $this.closest('.option-group');

            $group.find('label').removeClass('active');
            $this.parent().addClass('active');

            $group.removeClass('not-selected');
            $group.find('option').attr('selected', false);
            $group.find('option[value="' + selection + '"]').attr('selected', true);
            $group.find('select').trigger('change');
            
            $group.find('.validation-error').addClass('hide');
            
            //do other stuff on click
            if( $group.hasClass('option-group--color') ){
               $('.product-upsell--current-product img').attr('src', $(this).data('image'));
            }
        });
        

        //every time a select (option) changes build an array of the currently selected options
        var $options = $('.product-options-check .option-group select');
       
        $options.change(function () {

            
            var $this = $(this);
      
			var $group = $this.closest('.option-group');
            var $parent = $this.closest('.product-options-check');
            var $productSelect = $parent.find('.product-select');
            var $alloptions = $parent.find('.option-group select');
            var possibleOptions = $productSelect.data('options').split(',');
            var optionValue = $this.val();
            var optionName = $this.attr('name');
            var currentOptions = [];
			
			 $group.removeClass('not-selected');

            var otherOptions = possibleOptions.filter(function (obj) {
                return obj !== optionName;
            });
            
            $.each(otherOptions, function () {
                var data = { name: optionName, value:optionValue };
                checkAvailableOptions( $parent.find('.option-group[data-type="'+this+'"]'), data);
            });

            $alloptions.each(function () {
                currentOptions.push($(this).val());
            });

            if (!$parent.find('.not-selected').length) {
                updateProductSelect($parent, currentOptions);
            }

        });
        
        function checkAvailableOptions( $optionGroup, data ){
        
            var $parent = $optionGroup.closest('.product-options-check');
            var $productSelect = $parent.find('.product-select');
            var optionName = $optionGroup.data('type');
            var currentOptionName = optionName;

            var enabledOptions = [];

            $optionGroup.find('button').each(function(){
                var optionValue = $(this).val();
                if( data ){
                    optionName = data.name;
                    optionValue = data.value;
                }

                $productSelect.find('option[data-' + optionName + '="' + optionValue + '"]:not([data-instock="false"])').each(function () {
                    enabledOptions.push($(this).attr('data-' + currentOptionName));
                });
            });

            //go through each of the buttons and if its not part of the enabled options diable that button 
            $parent.find('button[data-type="' + currentOptionName + '"]').each(function () {
                if (enabledOptions.indexOf($(this).val()) > -1) {
                    $(this).removeClass('disabled');
                } else {
                    $(this).addClass('disabled');
                }
            });

        };

        function updateProductSelect($el, currentOptions) {
            
            var $productSelect = $el.find('.product-select');

            $productSelect.find('option').each(function () {
                if (!$(this).data('options')) {
                    return;
                }
                var options = $(this).data('options').split(',');
                if (options.sort().join(',') == currentOptions.sort().join(',')) {
                    $productSelect.find('option').attr('selected', false);
                    $(this).attr('selected', true);
                    $productSelect.val($(this).val());
                    //if price needs to be updated it can be done here
                    
//                    console.log()
                    
                    $('.price .main').text( $(this).data('price') );
                    
//                    console.log($(this).val());
//                    console.log($('.product-image[data-variant='+ $(this).val() +']'));
                    
                    var sIndex = $('.product-image[data-variant='+ $(this).val() +']').parent().parent().data('slick-index');
                    $('.product-intro__slider').slick('slickGoTo',sIndex);
                    
                    return
                }
            });
        }

    }());
    
//    var ourTeam = (function () {
//
//        var $sliders = $('.team-slider');
//
//        if ($sliders.length) {
//
//            $sliders.each(function () {
//                
//                $slider = $(this);
//
//                $slider.slick({
//                    slidesToShow:1,
//                    infinite: false,
//                    autoplay: true,
//                    arrows: false,
//                    dots: true,
//                    mobileFirst: true,
////                    prevArrow: $(this).parent().find('.slick-prev'),
////                    nextArrow: $(this).parent().find('.slick-next'),
//                    mobileFirst: true,
//                    responsive:[
//                        {
//                            breakpoint: 400,
//                            settings:
//                            {
//                                slidesToShow:1.25,
//                            }
//                        },
//                        {
//                            breakpoint: 500,
//                            settings:
//                            {
//                                slidesToShow:1.5,
//                            }
//                        },
//                        {
//                            breakpoint: 600,
//                            settings:
//                            {
//                                slidesToShow:1.75,
//                            }
//                        },
//                        {
//                            breakpoint: 700,
//                            settings:
//                            {
//                                slidesToShow:2,
//                            }
//                        },
//                        {
//                            breakpoint: 800,
//                            settings:
//                            {
//                                slidesToShow:2.25,
//                            }
//                        },
//                        {
//                            breakpoint: 900,
//                            settings:
//                            {
//                                slidesToShow:2.5,
//                            }
//                        },
//                        {
//                            breakpoint: 960,
//                            settings:
//                            {
//                                slidesToShow:3,
//                            }
//                        }
//                    ]
//                });
//
//            });
//
//        }
//
//    }());
    
    
    var contactPage = (function(){
        
        var $form = $('.contact-template__form form');
        var _parsley = $('.contact-template__form form').parsley();


        $form.submit(function(e){
            if( _parsley.validate() ){

            }else{
                e.preventDefault();
            }
            
        });
        
    }());
    
    
    var supportPage = (function(){
        
        if( $('body').hasClass('template-page-support') ){

            var $form = $('.support-page__intro form');
            var _parsley = $('.support-page__intro form').parsley();


            $form.submit(function(e){
                if( _parsley.validate() ){

                }else{
                    e.preventDefault();
                }

            });

    //        $('#00N1U00000UiL80').on('change', function(e) {
    //            
    //            clearRequired();
    //
    //            var requested = $(this).val();
    //            
    //            if (requested == "Replacement Parts") {
    //                $('#00N1U00000UiL6T, #00N1U00000UiL6Y, #00N1U00000UiL6d, #00N1U00000UiL7R, #00N1U00000UiL7b').attr('required', true);
    ////                $('#00N1U00000UiL6T, #00N1U00000UiL6Y, #00N1U00000UiL6d, #00N1U00000UiL7R, #00N1U00000UiL7b').siblings().append('*');
    //            }
    //
    //            if (requested == "Product Non-Operational" || requested == "Product Damaged / Broken") {
    //                $('#00N1U00000UiL6T, #00N1U00000UiL6Y, #00N1U00000UiL6d, #00N1U00000UiL7R, #00N1U00000UiL7b, #00N1U00000UmZhE, #00N1U00000UiL7v, #00N1U00000UiL6i').attr('required', true);
    //                $('#00N1U00000UiL6T, #00N1U00000UiL6Y, #00N1U00000UiL6d, #00N1U00000UiL7R, #00N1U00000UiL7b, #00N1U00000UmZhE, #00N1U00000UiL7v, #00N1U00000UiL6i').siblings().append('*');
    //                $("#date-span").append('*');
    //            }
    //
    //            if (requested == "Wrong Item Received" || requested == "Order Shipping Questions" || requested == "Cancel Order") {
    //                $('#00N1U00000UiL7W').attr('required', true);
    //                $('#00N1U00000UiL7W').siblings().append('*');
    //            }
    //
    //        });
    //
    //
    //        function clearRequired() {
    //            $('.contact-new .required input').attr('required', false);
    //            $('.contact-new .required span').each(function() {
    //                if (!$(this).hasClass("dateInput")) {
    //                    var t = $(this).text();
    //                    t = t.replace(/\*$/, '');
    //                    $(this).text(t);
    //                }
    //            });
    ////            var text = $("#date-span").text().replace(/\*$/, '');
    //            $("#date-span").text(text);
    //        }


             $("#00N1U00000UiL7v").datepicker();
            
        }
        
    }());
    
        var singlePost = (function () {

        if ($('body').hasClass('template-article')) {

            $headings = $('.article__content h2');

            if ($headings.length) {

                $('.article').addClass('article--toc');
                
                $('.toc').show();

                $headings.each(function () {
                    var text = $(this).text().replace(':', '');
                    //                console.log(text);
                    var id = text.replace(/[^a-z0-9\s]/gi, '').replace(/[_\s]/g, '-').toLowerCase();
                    $(this).attr('id', id);

                    $('.toc ul').append('<li><button class="reset" data-target="' + id + '">' + text + '</button>');
                });

                $('.toc').on('click', 'button', function () {
                    //                $('.toc li.active').removeClass('active');
                    //                $(this).parent().addClass('active');
                    var target = $(this).data('target');
                    $('html, body').animate({
                        scrollTop: $('h2#' + target).offset().top - 100
                    }, 1000);
                });

            }

            var $progressBar = $('.scroll-progress__bar')
            var lastScrollTop = 0;

            function updateProgress() {
                var scrollableHeight = $('.article__contents').outerHeight();
                var currentProgress = $('.article__contents').position().top + $('.article__contents').outerHeight();
//                console.log($('.article__contents').position().top);
                currentProgress = currentProgress - ($(window).scrollTop() + ($(window).height() / 2));
                currentProgress = 90 - ((currentProgress / scrollableHeight) * 100);
                $progressBar.css('width', currentProgress + '%');
                if ($('.toc').length) {

                    var scrollTop = $(window).scrollTop();

                    $headings.each(function () {
                        var elementOffset = $(this).offset().top,
                            distance = (elementOffset - scrollTop);

                        if (scrollTop > lastScrollTop) {
                            if (distance > 0 && distance < 250) {
                                var tocItem = $(this).attr('id');
                                $('.toc li.active').removeClass('active');
                                $('.toc button[data-target="' + tocItem + '"]').parent().addClass('active');
                            }
                        } else {
                            if (distance < (250) && distance < (500)) {
                                var tocItem = $(this).closest('h2').attr('id');
                                $('.toc li.active').removeClass('active');
                                $('.toc button[data-target="' + tocItem + '"]').parent().addClass('active');
                            }
                        }
                    });

                    lastScrollTop = scrollTop;

                }
            }
            $(window).scroll(updateProgress);
            $(window).resize(updateProgress);

        }

    }());

    
    var searchPage = (function(){
        
        var $filters = $('.search-filters input');
        var $form = $('.search-results__form')
        
        var types = urlParams.get('type');
        
        if( types ){
            $filters.each(function(){

                if( types.indexOf( $(this).val() ) > -1 ){
                    $(this).attr('checked', true);
                }

            });
        }
        
        
        $filters.change(function(){
            
            var $activeFilters = $('.search-filters input:checked');
            
            var filter = [];
            
            $activeFilters.each(function(){
            
                filter.push($(this).val());
                
            });
            
            filter = filter.join(',');
            
            $form.find('input[name="type"]').val( filter );
            
            $form.submit();
        });
        
    }());
    
    
    var genresSlider = (function(){
        
        $sliders = $('.top-genres__grid');
        
        $sliders.each(function(){
            
            $(this).slick({
                slidesToShow: 1,
//                centerMode: true,
                infinite:false,
                slidesToScroll: 1,
                arrows:false,
                dots: true,
                swipeToSlide: true,
                mobileFirst: true,
                prevArrow: $(this).parent().find('.prev'),
                nextArrow: $(this).parent().find('.next'),
                responsive:[
                    {
                        breakpoint: 450,
                        settings:
                        {
                            slidesToShow:1.25,
                        }
                    },
                    {
                        breakpoint: 600,
                        settings:
                        {
                            slidesToShow:1.5,
                        }
                    },
                    {
                        breakpoint: 720,
                        settings:
                        {
                            slidesToShow:1.75,
                        }
                    },
                    {
                        breakpoint: 768,
                        settings:
                        {
                            slidesToShow:2,
                        }
                    },
                    {
                        breakpoint: 960,
                        settings:
                        {
                            slidesToShow:3,
                            arrows:true,
                            dots:false,
                        }
                    }
                ]
            });
            
        });
        
    }());
	
	var subscriptionSelect = (function(){
		
		var $plans = $('.subscription-card__plans');
		
		$plans.change(function(){
			
			var $this = $(this);
			var plan = $this.val();
			
			$this.closest('.subscription-card').find('form').hide();
			$this.closest('.subscription-card').find('form[data-producthandle="'+plan+'"]').show();
			
		});
		
	}());
	
	var rechargeCheck = (function(){
		
		if( $('.recharge-te').length ){
			$('body').addClass('recharge-customer-templates');
		}
		
	}());
    
  var productRegistration = (function(){
        
        var $form = $('form.product-register');
		
		var $nav = $('form.product-register button');
		
		var _parsley = $form.parsley(parselyOptions);
	    var $sections = $form.find('.form-page');
		
		$sections.each(function(index, section) {
			$(section).find(':input').attr('data-parsley-group', 'block-' + index);
		});
		
		$nav.click(function(){
			
			var $this = $(this);
			var currentPage = $this.closest('.form-page').data('page');
			
			if( $this.data('action') == 'prev' ){
				
				var target = currentPage - 1;
				$this.closest('.form-page').removeClass('active');
				$('[data-page="'+target+'"]').addClass('active');
				
			}else{
				
				var target = currentPage + 1;
                var block = target - 2;
				
                _parsley.whenValidate({
                  group: 'block-' + block 
                }).done(function() {
                    $this.closest('.form-page').removeClass('active');
                    $('[data-page="'+target+'"]').addClass('active');
                });
				
			}
			
		});
		
	  /*      $form.submit(function(e){
            
            e.preventDefault();
            
            var ajaxURL = 'https://victrola.pdmdev.co/api/product-register.php';
            
            $.ajax({
                url: ajaxURL,
                type: 'post',
                data: $(this).serialize(),
                error: function (response) {
                    // Handle error response
                },
                success: function (response) {
                    // Handle successful response
                }
            });
            
        });*/
      
      
		
	}());
        
    
 

  

 
    $('.product-register').submit(function(e){
        e.preventDefault();
        var email = $(this).find('input[type="email"]').val(); 
        var firstName = $(this).find('#fname').val(); 
        var lastName = $(this).find('#lname').val(); 
        var modelNumber = $(this).find('#model').val();
        var serialNumber = $(this).find('#serial').val(); 
        var phoneNumber = $(this).find('#phone').val();  

        var address = $(this).find('#address').val();  
        var city = $(this).find('#city').val();  
        var state = $(this).find('#state').val();  
        var zip = $(this).find('#zip').val();  
        KlaviyoSubscribe('TGwFWh', email, 'Product Registration',modelNumber,serialNumber,phoneNumber,address,city,state,zip);
      
        $('form.product-register').hide();
        $('.registration-success').show();

    });

    
    function KlaviyoSubscribe(listID,email,source,modelNumber,serialNumber,phoneNumber,address,city,state,zip) {
        $.ajax({
            type: "POST",
            url: "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
            data: {
            g: listID,
                email: email,
                //pass in additional fields
                $fields: "$source, $first_name, $last_name, firstName, lastName, modelNumber, serialNumber, phoneNumber, address, city, state, zip",
                $source: source,
                modelNumber: modelNumber,
                serialNumber: serialNumber,
                phoneNumber: phoneNumber,
                address: address,
                city: city,
                state: state,
                zip: zip
            },
            contentType: "application/x-www-form-urlencoded",
            error: function (err) {
                // Handle Klaviyo connection error
            },
            success: function (data) {
                // Handle successful Klaviyo response
            }
        });
    }
  
$('.inquiry-type select').change(function() {
	 var value = $(this).val();
	// if Product Tech Support
	if(value == "Product Technical Support") {
		$(".product-tech-row").show();
		$(".online-order-row").hide();
		$(".other-selection").hide();
	}
	// if Online Order Support
	else if(value == "Online Order Support") {
		$(".online-order-row").show();
		$(".product-tech-row").hide();
		$(".other-selection").hide();
	} // if Other
	else if(value == "Other") {
		$(".online-order-row").hide();
		$(".product-tech-row").hide();
		$(".other-selection").show();
	} else {
		$(".online-order-row").hide();
		$(".product-tech-row").hide();
		$(".other-selection").hide();
	}
});
    
$('.retailer-select select').change(function() {
  	 var value = $(this).val();
  if(value == "Other") {
  	$(this).closest(".row").find(".place-of-purchase").show();
  } else {
     $(this).closest(".row").find(".place-of-purchase").hide();
  }

    
});

  $(document).on('click','.direct-add',function(){
    const cartFlyout = document.querySelector('.cart-flyout');
    var id= $(this).attr('data-id');
    var btn = $(this);

    // if the cart flyout exists, re render and make it pop out after product
    // is added to cart, otherwise just add product (B2B)
    if ( cartFlyout ) {
      const body = JSON.stringify({
        'items': [{
          'id': id,
          'quantity': 1
        }],
        sections: cartFlyout.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });
      fetch(`${window.Shopify.routes.root + 'cart/add.js'}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          btn.addClass("disabled");
           btn.text("Added");
          const parsedState = JSON.parse(state);
          cartFlyout.reloadContent(parsedState);
        });
    } else {
      const body = JSON.stringify({
        'items': [{
          'id': id,
          'quantity': 1
        }],
        sections: 'header'
      });
      fetch(`${window.Shopify.routes.root + 'cart/add.js'}`, {...fetchConfig(), ...{ body }})
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          btn.addClass("disabled");
          btn.text("Added");
          if (response.sections && response.sections.header) {
            const parser = new DOMParser();
            const dom = parser.parseFromString(response.sections.header, "text/html");
            const newCountEl = dom.querySelector('.cart-icon_item-count');
            if (newCountEl) {
              document.querySelectorAll('.cart-icon_item-count').forEach((el) => {
                el.innerHTML = newCountEl.innerHTML;
              });
            }
            const newB2B = dom.getElementById('b2b-cart-count');
            if (newB2B && document.getElementById('b2b-cart-count')) {
              document.getElementById('b2b-cart-count').innerHTML = newB2B.innerHTML;
            }
          }
          if (window.cartNotification && response.items) {
            window.cartNotification.show(response.items);
          }
        });
    }
  })

var bundleSKU = (function () {
	$bundles = $('.current-sku');
   if (!$bundles.length) { return };
	var selectMenu = $(".product-options-check .option-group select");
	$(selectMenu).on('change', function() {
		var productSelect = $(this).closest('form').find('.product-select');
		var variantSKU = $(productSelect).find(":selected").data("sku");
		var input = $(this).closest('form').find('.current-sku');
        $(input).val(variantSKU);
	});
	
}());

var Tabs = (function () {
    $('.tabgroup > div').hide();
    $('#tabMembership').show();
    $('.tabs button').click(function (e) {
        e.preventDefault();
        var $this = $(this),
            tabgroup = '#' + $this.parents('.tabs').data('tab'),
            others = $this.closest('.tabs').find("button");
        target = $this.data('tab');
        others.removeClass('active');
        $this.addClass('active');
        $('.tabgroup > div').hide();
        $(target).show();

    })
}());

var classAfter = (function () {
	 setTimeout(function() { 
        $(".afterpay-paragraph").addClass("test");
    }, 5000);
}());
  
  var  colorSelect = (function() {
    $(".color_trigger").click(function(){
     	$(this).next().toggle();
    });
  }());

  // Customer Forgot Password Toggle    
  $('.formToggle').click(function(){
      $('.login').toggleClass('login--register');
  });

  if( window.location.hash == "#recover" ){
      $('#ResetSuccess').show();
      $('.login').hide();
  }
});

// **************** VINYL CUSTOM SCRIPTS ********************

// Scroll Listeners
let scrollIndex, lastScrollPos, ticking;
lastScrollPos = 0;
ticking = false;
const el = this;
window.addEventListener( 'scroll', function() {
  // sets scrollIndex to indicate scrolling up or down
  if ( window.pageYOffset < lastScrollPos ) {
    scrollIndex = -1;
  } else {
    scrollIndex = 1;
  }
  lastScrollPos = window.pageYOffset;

  // throttling the event
  if ( ! ticking ) {
    window.requestAnimationFrame( function() {
      // CALL SCROLL TRIGGERED FUNCTIONS HERE

      checkNav(); // sticky nav

      ticking = false;
    } );

    ticking = true;
  }
} );


// Scroll off top
const navContainer = document.querySelector('.header__main-container');
const navMain = document.querySelector('.header__main');
const announcementBar = document.querySelector('.header__banner');
const megaMenus = document.querySelectorAll('.mega-menu');

const stickyStart = navContainer.offsetTop;

function checkNav() {
  const shouldStick = lastScrollPos > stickyStart;

  if (shouldStick && !navMain.classList.contains('sticky')) {
    navMain.classList.add('sticky', 'sticky-enter');
    announcementBar?.classList.add('is-hidden');

    requestAnimationFrame(() => {
      navMain.classList.remove('sticky-enter');
      navMain.classList.add('sticky-ready');
    });

    megaMenus.forEach((menu) => {
      menu.classList.add('off-top');
    });
  }

  if (!shouldStick && navMain.classList.contains('sticky')) {
    navMain.classList.remove('sticky', 'sticky-ready', 'sticky-enter');

    requestAnimationFrame(() => {
      announcementBar?.classList.remove('is-hidden');
    });

    megaMenus.forEach((menu) => {
      menu.classList.remove('off-top');
    });
  }
}


// PRODUCT CARD VARIANT SELECTORS
if ( document.querySelector('.product-card__variants') ) {
  initProductCardVariants();
  // need to add this to reinitialize when the pagination is clicked, bc it does not navigate to new page
  if ( document.querySelector('.bc-sf-filter-bottom-pagination') ) {
    document.querySelector('.bc-sf-filter-bottom-pagination').addEventListener('click', initProductCardVariants);
  }
}

// look for all product cards on page, loop through each to initialize variant swatch buttons
function initProductCardVariants() {
  const productCardWrappers = document.querySelectorAll('.product-card__wrapper');
  productCardWrappers.forEach( (card) => initVariantSelectors(card));
}

// if the card has variant swatches, add listener to toggle the variant and image on click
function initVariantSelectors(card) { 
  if (card.querySelector('.product-card__variants')) {
    const variantOptions = card.querySelectorAll('.product-card__variant-color');
    variantOptions.forEach( (variant) => variant.addEventListener('click', function(e) {
      toggleVariant(e.currentTarget, card);
    }))
  }
}

function toggleVariant(colorButton, card) {
  const productCardImage = card.querySelector('.product-card__featured-image');

  // swap src and srcset
  const newImage = colorButton.dataset.variantimage;
  if (productCardImage) {
    productCardImage.src = newImage;
    productCardImage.srcset = newImage; // reset to a single URL
  }

  // toggle "selected" class on buttons
  card.querySelectorAll('.product-card__variant-color')
      .forEach(color => color.classList.remove('selected'));
  colorButton.classList.add('selected');

  // change product id of "quick add" button
  const quickAddButton = card.querySelector('.direct-add');
  if (quickAddButton) {
    quickAddButton.dataset.id = colorButton.dataset.variantid;
  }
}




// // PRODUCT CARD HEIGHT
// if ( document.querySelector('.product-card__wrapper') ) {
//   const productCards = document.querySelectorAll('.product-card__wrapper');
//   let tallestCard = 0;
//   productCards.forEach( (card) => {
//     if ( card.offsetHeight > tallestCard ) {
//       tallestCard = card.offsetHeight;
//     }
//   })
  
//   productCards.forEach( (card) => {
//     card.style.height = tallestCard + 'px';
//   })
// }

// B2B SCRIPT

if ( document.querySelector('.b2b-burger') ) {
  const b2bBurger = document.querySelector('.b2b-burger');
  const b2bMenu = document.querySelector('.b2b-main-nav');
  b2bBurger.addEventListener('click', function() {
    b2bMenu.classList.toggle('open');
  });
}

// Global Accordion Functionality - Reusable across PDP sections
function initializeAccordions() {
  // Find all accordion headers on the page
  const accordionHeaders = document.querySelectorAll('.accordion_section_heading');
  console.log('Found accordion headers:', accordionHeaders.length);
  
  accordionHeaders.forEach(function(header) {
    // Skip if already initialized
    if (header.hasAttribute('data-accordion-initialized')) {
      return;
    }
    
    // Mark as initialized
    header.setAttribute('data-accordion-initialized', 'true');
    
    // Find the corresponding content
    const content = header.nextElementSibling;
    console.log('Initializing accordion:', header, content);
    
    // Add click event listener
    header.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      console.log('Accordion clicked');
      toggleAccordion(this, content);
    });
  });
}

// Use MutationObserver to detect when accordion elements are added to the DOM
function observeAccordions() {
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach(function(node) {
          if (node.nodeType === 1) { // Element node
            if (node.classList && node.classList.contains('accordion_section_heading')) {
              console.log('New accordion header detected:', node);
              initializeAccordions();
            } else if (node.querySelector && node.querySelector('.accordion_section_heading')) {
              console.log('New accordion container detected:', node);
              initializeAccordions();
            }
          }
        });
      }
    });
  });
  
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
}

function toggleAccordion(header, content) {
  console.log('Toggling accordion:', header, content);
  // Toggle active class on header
  header.classList.toggle('active');
  
  // Toggle active class on content
  if (content && content.classList.contains('accordion_section_content')) {
    content.classList.toggle('active');
    console.log('Content toggled, classes:', content.classList.toString());
  }
}

// Function to manually initialize accordion for dynamically added content
window.initAccordion = function(element) {
  const header = element.querySelector('.accordion_section_heading');
  if (header && !header.hasAttribute('data-accordion-initialized')) {
    header.setAttribute('data-accordion-initialized', 'true');
    const content = header.nextElementSibling;
    header.addEventListener('click', function() {
      toggleAccordion(this, content);
    });
  }
};

// Initialize accordions with multiple strategies
function initAccordionsWithDelay() {
  setTimeout(function() {
    console.log('Initializing accordions with delay...');
    initializeAccordions();
  }, 100);
  
  setTimeout(function() {
    console.log('Re-initializing accordions after longer delay...');
    initializeAccordions();
  }, 500);
  
  setTimeout(function() {
    console.log('Final accordion initialization...');
    initializeAccordions();
  }, 1000);
}

// Initialize accordions when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  console.log('DOM loaded, initializing accordions...');
  initAccordionsWithDelay();
  observeAccordions();
});

// Also initialize on window load as backup
window.addEventListener('load', function() {
  console.log('Window loaded, re-initializing accordions...');
  initAccordionsWithDelay();
});

// Initialize immediately if DOM is already ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initAccordionsWithDelay();
    observeAccordions();
  });
} else {
  console.log('DOM already ready, initializing accordions immediately...');
  initAccordionsWithDelay();
  observeAccordions();
}

let yotpoInitialized = false;
let yotpoObserver = null;

function handleYotpoReviewsButtonClick() {
  const reviewsContainer = document.getElementById('product_nav_reviews');
  const accordionSection = reviewsContainer?.querySelector('.accordion_section_heading');
  
  if (reviewsContainer && accordionSection) {
    reviewsContainer.scrollIntoView({ 
      behavior: 'smooth', 
      block: 'start' 
    });
    setTimeout(() => {
      accordionSection.click();
    }, 500);
  }
}

function attachYotpoReviewsButtonListener() {
  if (yotpoInitialized) {
    return true;
  }
  const reviewsButton = document.querySelector('.bv_button_buttonFull');
  
  if (reviewsButton) {
    reviewsButton.removeEventListener('click', handleYotpoReviewsButtonClick);
    reviewsButton.addEventListener('click', handleYotpoReviewsButtonClick);
    yotpoInitialized = true;
    if (yotpoObserver) {
      yotpoObserver.disconnect();
      yotpoObserver = null;
    }
    return true;
  }
  return false;
}

function initializeYotpoReviewsButton() {
  if (yotpoInitialized) {
    return;
  }
  
  if (!attachYotpoReviewsButtonListener()) {
    if (!yotpoObserver) {
      yotpoObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            mutation.addedNodes.forEach(function(node) {
              if (node.nodeType === 1) {
                if (node.classList && node.classList.contains('bv_button_buttonFull')) {
                  attachYotpoReviewsButtonListener();
                } else if (node.querySelector && node.querySelector('.bv_button_buttonFull')) {
                  attachYotpoReviewsButtonListener();
                }
              }
            });
          }
        });
      });
      
      yotpoObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
      
      setTimeout(() => {
        attachYotpoReviewsButtonListener();
      }, 2000);
      
      setTimeout(() => {
        if (yotpoObserver) {
          yotpoObserver.disconnect();
          yotpoObserver = null;
        }
      }, 10000);
    }
  }
}

document.addEventListener('DOMContentLoaded', function() {
  initializeYotpoReviewsButton();
});

window.addEventListener('load', function() {
  initializeYotpoReviewsButton();
});

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    initializeYotpoReviewsButton();
  });
} else {
  initializeYotpoReviewsButton();
}
